import { AccessGuids, ConfigSystemParams, ErrorStrings, FlatpickrFormat, OurColors, ToastShowDelay } from "src/app/core/consts";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Browser, divIcon, geoJSON, icon, Icon, IconOptions, latLng, latLngBounds, layerGroup, LayerGroup, Map, MapOptions, marker, Marker, tileLayer, TileLayer } from 'leaflet';
import { catchError, forkJoin, Observable, Subscription, tap, throwError } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompletedModalNRFormComponent } from 'src/app/forms-modal-confirmation/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalNRFormComponent } from "src/app/forms-modal-confirmation/confirmation-modal-form/confirmation-modal-form.component";
import { coordinateDTO } from 'src/app/core/models/system/mapping/coordinate.dto';
import { CountriesService } from 'src/app/core/services/utelize/system/mapping/countries-service';
import { CountryDTO } from 'src/app/core/models/system/mapping/country.dto';
import { CountryRiskLevelDTO } from 'src/app/core/models/system/riskline/riskline-country-risk-level.dto';
import { DatePipe } from '@angular/common';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { EsimLocationDTO } from 'src/app/core/models/system/webbing/esim-location.dto';
import { eTravelRiskDataProvider, LocationAwarenessStatus, LocationServicesZoomLevel } from 'src/app/core/enums';
import { eVisibilityChangeScope, LocationVisibilityChangeDTO } from 'src/app/core/models/system/location-awareness/location-visibility-change.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FeatureCollection } from 'geojson';
import { GlobalEventService } from 'src/app/core/services/utelize/general/global-event-service';
import { HttpClient } from '@angular/common/http';
import { LocationAwarenessService } from 'src/app/core/services/utelize/system/location-awareness/location-awareness-service';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { RisklineCountryRiskLevelsService } from 'src/app/core/services/riskline/riskline-country-risk-levels.service';
import { RisklineSharedService } from 'src/app/core/services/riskline/riskline-shared.service';
import { SignalsTravelRiskService } from 'src/app/core/services/signals/signals-travel-risk.service';
import { TravelRiskCountryLevelDTO } from 'src/app/core/models/system/signals/travel-risk-level.dto';
import { UserLocationAwarenessDTO } from 'src/app/core/models/system/location-awareness/user-location-awareness.dto';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalNRFormComponent } from 'src/app/forms-modal-confirmation/warning-modal-form/warning-modal-form.component';
import { WebbingLiveDataDTO } from 'src/app/core/models/system/webbing/live-data.dto';
import { WebbingService } from 'src/app/core/services/utelize/system/webbing/webbing-service';

//RBW_20260716 - Marker pins are drawn without a drop shadow (shadowUrl/shadowSize removed) so they look consistent across grouped and individual views
const iconBlue = icon({
  iconRetinaUrl:'assets/images/_suresim/marker-icon-blue-2x.png',
  iconUrl:'assets/images/_suresim/marker-icon-blue.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
});
const iconAmber = icon({
  iconRetinaUrl:'assets/images/_suresim/marker-icon-amber-2x.png',
  iconUrl:'assets/images/_suresim/marker-icon-amber.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
});
const iconGreen = icon({
  iconRetinaUrl:'assets/images/_suresim/marker-icon-green-2x.png',
  iconUrl:'assets/images/_suresim/marker-icon-green.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
});
const iconGrey = icon({
  iconRetinaUrl:'assets/images/_suresim/marker-icon-grey-2x.png',
  iconUrl:'assets/images/_suresim/marker-icon-grey.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
});
Marker.prototype.options.icon = iconBlue;

@Component({
  selector: 'app-map-sim-locations',
  templateUrl: './map-sim-locations.component.html',
  styleUrls: ['./map-sim-locations.component.scss']
})

export class MapSimLocationsComponent implements AfterViewInit, OnChanges, OnDestroy, OnInit {
  
  @Input() companyId                   : number | undefined;
  @Input() enableCountrySelection      : boolean = false;
  @Input() excludeAtHomeTravellers     : boolean = false;
  @Input() excludeIotDevices           : boolean = false;
  @Input() filterListToCountrySelection: boolean = false;
  @Input() fitWorldToWidth             : boolean = false;
  @Input() iccid                       : string | undefined;
  @Input() intendsRiskColouring        : boolean = false;
  @Input() keepKnownCountry            : boolean = false;
  //RBW_20260713 – Owning company of the SIM, supplied by the Manage SIM dialog; used to show the inherited company defaults in Inherit mode
  @Input() locationCompanyId           : number | undefined;
  //RBW_20260713 – Owning user of the SIM, supplied by the Manage SIM dialog; used for the user-level "outside home country only" home-guard toggle
  @Input() locationOwnerUserId         : number | undefined;
  @Input() openFullyZoomedOut          : boolean = false;
  //RBW_20260713 – Global Location Awareness screen shows the company settings read-only; they are edited from within the company, not here
  @Input() readOnlySettings            : boolean = false;
  @Input() riskDataSourceID            : eTravelRiskDataProvider = eTravelRiskDataProvider.SureSIM;
  @Input() selectedUserZoomLevel       : number | undefined;
  @Input() showRiskColouring           : boolean = false;
  @Input() showRiskLegend              : boolean = false;
  @Input() showTravelBriefing          : boolean = false;
  @Input() sidebarCollapsible          : boolean = false;
  @Input() sidebarOpenByDefault        : boolean = false;
  //RBW_20260713 – Wider sidebar (col-3) for the management dialogs where the Inherit/Override cards need room; the full-page Location Awareness screen leaves the default narrower col-2
  @Input() wideSidebar                 : boolean = false;
  @Input() worldZoomLevel              : number | undefined;
  
  @Output() containerClosed            : EventEmitter<void>=new EventEmitter<void>();
  @Output() countryHovered             : EventEmitter<string | undefined>=new EventEmitter<string | undefined>();
  @Output() countrySelectionChanged    : EventEmitter<string[]>=new EventEmitter<string[]>();
  @Output() editLocationConsentTemplate: EventEmitter<void>=new EventEmitter<void>();
  @Output() eSimManagerFormCancelled   : EventEmitter<void>=new EventEmitter<void>();
  @Output() locationDataLoaded         : EventEmitter<EsimLocationDTO[]>=new EventEmitter<EsimLocationDTO[]>();
  //RBW_20260713 – Emitted when a company Location Setting is changed so the Manage Company dialog can enable its Submit button (these controls live outside the company reactive form)
  @Output() locationSettingsChanged    : EventEmitter<void>=new EventEmitter<void>();
  @Output() sidebarCollapsedChange     : EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() travelBriefingRequested    : EventEmitter<{ countryName: string; iccid: string; username: string; }>=new EventEmitter<{ countryName: string; iccid: string; username: string; }>();
  
  @ViewChild('completedModalForm',      { static: false }) completedModalForm!     : CompletedModalNRFormComponent;
  @ViewChild('container'                                 ) container!              : ElementRef;
  @ViewChild('mapRef'                                    ) mapRef!                 : Map;
  @ViewChild('riskLegend',              { static: false }) set riskLegendRef(ref: ElementRef<HTMLElement> | undefined) {
    try {
      this.riskLegendElement=ref?.nativeElement;
      this.updateRiskLegendVisibility();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  @ViewChild('scrollContainer',         { static: false }) scrollContainer!        : ElementRef;
  @ViewChild('toggleConfirmationModal', { static: false }) toggleConfirmationModal!: ConfirmationModalNRFormComponent;
  @ViewChild('warningModalForm',        { static: false }) warningModalForm!       : WarningModalNRFormComponent;

  get effectiveHomeCountry   () { return this.userHomeCountry !== '' ? this.userHomeCountry : this.inheritedHomeCountry   ; }
  get filteredcoordinates    () { return this.applyCountrySelectionToList(this.filteredcoordinatesUnscoped)               ; }
  get isVisitMode            () { return this.iccid != undefined && !this.showCurrentLocation                             ; }
  get settingsPanelExpanded  () { return this.locationSettingsExpanded || this.mapSettingsExpanded                        ; }
  get showAllLocationCards   () { return (this.isVisitMode || this.companyId != undefined)
                                         && this.zoomedIn == LocationServicesZoomLevel.World
                                         && this.worldCardMode === 'allLocations'                                         ; }
  get showFullRangeOptions   () { return this.lastLocationOnlyResolved && !this.lastLocationOnlyActive                    ; }
  get showSidebarRevealButton() { return this.sidebarCollapsible && this.sidebarCollapsed                                 ; }
  get userHomeCountryDiffers () { return this.userHomeCountry !== '' && this.userHomeCountry !== this.inheritedHomeCountry; }

  get locationServicesTileURL        () { return this.configSystemService.getValue(ConfigSystemParams.LocationServicesTileURL, "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"); }
  get locationServicesTileAttribution() { return this.configSystemService.getValue(ConfigSystemParams.LocationServicesTileAttribution, "© OpenStreetMap contributors"              ); }

  get showLastLocationOnlyCompany () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LocationServicesLastLocationOnlyCompanyEnabled, true); }
  get showLastLocationOnlySim     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LocationServicesLastLocationOnlySimEnabled,     true); }
  get showMapSettings             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LocationServicesMapSettingsEnabled, true            )
                                       || this.componentAccessUserService.hasAccessGuid(AccessGuids.LocationServicesMapSettings, true                           ); }
  get suppressOriginalWebbingError() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.WebbingSuppressOriginalError, true                  ); }

  get showUserOptIn(): boolean {
    return this.componentAccessUserService.hasAccessGuid(AccessGuids.LocationAwarenessUserOptIn, true);
  }

  get locationAwaitingConsent(): boolean {
    return this.locationAwarenessStatusId === LocationAwarenessStatus.AwaitingConfirmation;
  }

  get lastLocationOnlyActive(): boolean {
    if (this.iccid == undefined) return false;
    if (this.locationSettingsOverride && this.showLastLocationOnlySim)
      return this.locationLastLocationOnly;
    return this.showLastLocationOnlyCompany ? this.inheritedLastLocationOnly : false;
  }
  
  get mapColumnClass(): string {
    if (this.sidebarCollapsible && this.sidebarCollapsed)
      return 'col-12';

    return this.wideSidebar ? 'col-9' : 'col-10';
  }

  get filterStartMs(): number {
    if (this.filterDateStart == undefined) return -1;
    return this.historyDateRange === 'custom'
           ? new Date(this.filterDateStart.date.getFullYear(), this.filterDateStart.date.getMonth(), this.filterDateStart.date.getDate()).getTime()
           : this.filterDateStart.date.getTime();
  }
  get filterEndMs(): number {
    if (this.filterDateEnd == undefined) return -1;
    return this.historyDateRange === 'custom'
           ? new Date(this.filterDateEnd.date.getFullYear(), this.filterDateEnd.date.getMonth(), this.filterDateEnd.date.getDate() + 1).getTime()
           : this.filterDateEnd.date.getTime();
  }

  private get filteredcoordinatesUnscoped(): coordinateDTO[] {
    const filterStartMidnight  = this.filterStartMs;
    const filterEndNextDay     = this.filterEndMs;
    if (this.locationCoordinates != undefined && this.locationCoordinates.length > 0) {
      const term = this.searchTerm.toLowerCase();
      if (this.zoomedIn != LocationServicesZoomLevel.World) {
        if (this.isVisitMode && this.filterDateEnd != undefined && this.filterDateStart != undefined) {
          let coords = this.locationCoordinates.filter(c => c.visitId == this.selectedVisitId && c.startDate != undefined &&
                  ((c.startDate.date.getTime() >= filterStartMidnight && c.startDate.date.getTime() < filterEndNextDay))
                   ).sort((a, b) => (b.endDate?.date.getTime() ?? 0) - (a.endDate?.date.getTime() ?? 0));
          return coords;
        }
        if (term == '') {
          let coords = this.locationCoordinates.filter(c => c.countryId == this.selectedCountryId).sort((a, b) => (a.username ?? '').localeCompare(b.username ?? ''));
          return coords;
        }
        let coords = this.locationCoordinates.filter(c => c.countryId == this.selectedCountryId && c.username?.toLowerCase().includes(term)).sort((a, b) => (a.username ?? '').localeCompare(b.username ?? ''));
        return coords;
      }
      //RBW_20260715 - Company/global "All Sims" world view: list every SIM individually (available at all accuracies) instead of grouping by country
      if (this.companyId != undefined && this.showAllLocationCards) {
        const allSims = term == ''
                        ? this.locationCoordinates
                        : this.locationCoordinates.filter(c => (c.username ?? '').toLowerCase().includes(term) ||
                                                               (c.iccid    ?? '').toLowerCase().includes(term));
        return [...allSims].sort((a, b) => (a.username ?? '').localeCompare(b.username ?? ''));
      }
      if (this.isVisitMode && this.filterDateEnd != undefined && this.filterDateStart != undefined) {
        if (this.worldCardMode === 'allLocations') {
          return this.locationCoordinates.filter(c => c.startDate != undefined &&
                  ((c.startDate.date.getTime() >= filterStartMidnight && c.startDate.date.getTime() < filterEndNextDay))
                   ).sort((a, b) => ((b.endDate?.date.getTime() ?? 0) - (a.endDate?.date.getTime() ?? 0)) ||
                                    ((b.visitId ?? 0) - (a.visitId ?? 0)));
        }
        const seenVisits = new Set<number>();
        const visitCoords = this.countryLocationCoordinates.filter(c => c.startDate != undefined &&
                ((c.startDate.date.getTime() >= filterStartMidnight && c.startDate.date.getTime() < filterEndNextDay))
                 ).filter(entry => {
          const key = entry.visitId ?? -1;
          if (seenVisits.has(key)) {
            return false;
          }
          seenVisits.add(key);
          return true;
        });
        visitCoords.sort((a, b) => this.getVisitMaxTime(b) - this.getVisitMaxTime(a));
        return visitCoords;
      }

      const seen = new Set<string>();
      var coords : coordinateDTO[];
      if (term == '') {
        if (this.iccid != undefined && !this.showCurrentLocation && this.filterDateEnd != undefined && this.filterDateStart != undefined) {
          coords = this.countryLocationCoordinates.filter(c => c.startDate != undefined &&
                  ((c.startDate.date.getTime() >= filterStartMidnight && c.startDate.date.getTime() < filterEndNextDay))
                   ).
          filter(entry => {
           if (seen.has(entry.country ?? '')) {
             return false;
           }
           seen.add(entry.country ?? '');
           return true;
          });
        } else {
          coords = this.countryLocationCoordinates.
          filter(entry => {
           if (seen.has(entry.country ?? '')) {
             return false;
           }
           seen.add(entry.country ?? '');
           return true;
          });
        }
      } else {
        coords = this.countryLocationCoordinates.filter(item =>
          (item.username ?? '').toLowerCase().includes(term)
        ).filter(entry => {
          if (seen.has(entry.country ?? '')) {
            return false;
          }
          seen.add(entry.country ?? '');
          return true;
        });
      }
      coords.sort((a, b) => (a.country ?? '').localeCompare(b.country ?? ''));
      return coords; 
    }
    return [];
  }

  get filteredcountrycoordinates() {
    const filterStartMidnight  = this.filterStartMs;
    const filterEndNextDay     = this.filterEndMs;
    if (this.countryLocationCoordinates != undefined && this.countryLocationCoordinates.length > 0) {
      const term = this.searchTerm.toLowerCase();
      var coords : coordinateDTO[];
      if (term == '') {
        if (this.iccid != undefined && !this.showCurrentLocation && this.filterDateEnd != undefined && this.filterDateStart != undefined) {
          coords = this.countryLocationCoordinates.filter(c => c.startDate != undefined &&
                  ((c.startDate.date.getTime() >= filterStartMidnight && c.startDate.date.getTime() < filterEndNextDay))
                   ).sort((a, b) => (a.username ?? '').localeCompare(b.username ?? ''));
        } else {
          coords = this.countryLocationCoordinates;
        }
      } else {
        coords = this.countryLocationCoordinates.filter(item =>
          (item.username ?? '').toLowerCase().includes(term)
        );
      }  
      return coords;
    }
    return [];
  }

  //RBW_20260715 - Guards the one-off initial location fetch so the map-settle timer and the async device response don't double-fetch (see tryInitialLocationLoad)
  private _initialLoadRetryCount          : number  = 0;
  private _initialLoadRetryPending        : boolean = false;
  private _initialLocationLoadDone        : boolean = false;
  private _isIccidClickLoading            : boolean = false;
  private _suppressFitOnNextWorldZoom     : boolean = false;
  private _userSelectedDuringLoad         : boolean = false;
  private activeTileLayer !               : TileLayer;
  private blankCoordinate                 : coordinateDTO = { 
                                              country: '', 
                                              countryFlag: '', 
                                              countryId: -1, 
                                              dateRange:'',  
                                              distanceFromCountryPolygon: 0,
                                              endDate: undefined, 
                                              iccid: '', 
                                              id: -1, 
                                              label: 'World Map', 
                                              lat: 45, 
                                              lng: 0, 
                                              network: '',
                                              placeName: '', 
                                              simCount: 0, 
                                              startDate: undefined, 
                                              username: '' };

  private bubblesAutoSwappedToPins         : boolean=false;
  private historySnapshot                  : { range: 'last' | '24h' | '7d' | '30d' | 'custom', start: OurDate | undefined, end: OurDate | undefined, applied: boolean, label: string } | undefined;
  private lastAggregatesReplacePins        : boolean | undefined = undefined;
  private lastLocationOnlyCompanyResolved  : boolean = false;
  private lastLocationOnlyResolved         : boolean = false;
  private lastLocationOnlyUserResolved     : boolean = false;
  private localToastTimer                  : any;
  private locationAccuracyLevelOriginal    : number  = 3;
  private locationCompany                  : CompanyDTO | undefined;
  private locationHomeGuardOriginal        : boolean = false;
  private locationLastLocationOnlyOriginal : boolean = false;
  private locationServicesChangedSub       : Subscription | undefined;
  private locationServicesOriginal         : boolean | undefined = undefined;
  private locationSettingsDirty            : boolean = false;
  private locationSettingsOverrideOriginal : boolean = false;
  private locationTrackingDirty            : boolean = false;
  private locationTrackingRequestedOriginal: boolean | undefined = undefined;
  private pendingLocationRequests          : number = 0;
  private riskCountBubblesLayer            : LayerGroup | undefined;
  private riskLegendElement                : HTMLElement | undefined;
  private selectedCountryIsos              : string[]=[];
  private simDeviceLoadFinished            : boolean = false;
  private simDeviceLoadRequested           : boolean = false;

  private readonly instanceId: string = Math.random().toString(36).substring(2);

  public appliedRangeLabel             : string = '';
  public countryLayer                  : any;
  public countryLocationCoordinates    : coordinateDTO[] = [];
  public countryStats                  : {
                                           countryId: number,
                                           maxDate  : OurDate | undefined,
                                           minDate  : OurDate | undefined,
                                           simCount : number,
                                           visitId  : number | undefined
                                         }[] = [];
  public currentLocationData           : EsimLocationDTO | undefined;
  public customRangeApplied            : boolean = false;
  public customRangeEditing            : boolean = false;
  public expandContainer               : boolean=true;
  public expandedGroupKey              : number | undefined = undefined;
  public filterDateEnd                 : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public filterDateFormat              : string=FlatpickrFormat.Day_MonthWordFull_Year;
  public filterDateStart               : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now() - 7 * 24 * 60 * 60 * 1000);
  public filteredItems                 : coordinateDTO[] = [...this.filteredcoordinates];
  public geoData                       : any;
  public geoJsonLayer                  : any;
  public historyDateRange              : 'last' | '24h' | '7d' | '30d' | 'custom' = 'last';
  public inheritedAccuracyLevel        : number = 3;
  public inheritedHomeCountry          : string = '';
  public inheritedHomeGuard            : boolean = false;
  public inheritedLastLocationOnly     : boolean = false;
  public latLng                        : string = '';
  public loading                       : boolean = true;
  public localToastMessage             : string = '';
  public localToastRight               : number = 16;
  public localToastTop                 : number = 16;
  public localToastVisible             : boolean = false;
  public locationAccuracyLevel         : number = 3;
  public locationAccuracyView          : number = 0;
  public locationAwarenessStatusDescription: string = 'Off';
  public locationAwarenessStatusId     : number = 1;
  public locationChangeReason          : string = '';
  public locationConsentResending      : boolean = false;
  public locationCoordinates           : coordinateDTO[] = [];
  public locationCountryAlwaysVisible  : boolean = false;
  public locationData                  : EsimLocationDTO[] | undefined;
  public locationEnableForNewByDefault : boolean = false;
  public locationHomeGuardView         : number = -1;
  public locationLastLocationOnly      : boolean = false;
  public locationOutsideHomeCountryOnly: boolean = false;
  public locationRequireUserOptIn      : boolean = true;
  public locationServices              : boolean | undefined = undefined;
  public locationServicesToggleAction  : string = "";
  public locationSettingsExpanded      : boolean = false;
  public locationSettingsLoaded        : boolean = false;
  public locationSettingsOverride      : boolean = false;
  public locationSettingsSaving        : boolean = false;
  public locationTrackingRequested     : boolean | undefined = undefined;
  public locationTrackingView          : number = -1;
  public map!                          : Map;
  public mapOptions!                   : MapOptions;
  public mapSettingsExpanded           : boolean = false;
  public markersLayer!                 : LayerGroup;
  public riskDisplayMode               : 'auto' | 'live' | 'map' | 'risk'='auto';
  public riskLevelByIso                : Record<string, number>={};
  public searchTerm                    : string = '';
  public selectedCoordinate            : coordinateDTO | undefined = this.blankCoordinate;
  public selectedCountryId             : number | undefined;
  public selectedTileLayerLabel        : string = 'Default';
  public selectedUserCoordinate        : coordinateDTO | undefined = this.blankCoordinate;
  public selectedUserId                : number | undefined;
  public selectedVisitId               : number | undefined;
  public showCountBubbles              : boolean=true;
  public showCountries                 : boolean=false;
  public showCurrentLocation           : boolean=true;
  public showDropdown                  : boolean = false;
  public sidebarCollapsed              : boolean=true;
  public sureSimDevice                 : DeviceDTO | undefined;
  public sureSimLiveData               : WebbingLiveDataDTO | undefined;
  public tileLayerOptions              : { label: string; layer: TileLayer }[] = [];
  public toggleInProgress              : boolean= false;
  public travelRiskExtendedOfflineHours: number | null = null;
  public userHomeCountry               : string = '';
  public visibilityChanges             : LocationVisibilityChangeDTO[]=[];
  public visibilityChangesExpanded     : boolean = false;
  public visibilityChangesLoading      : boolean = false;
  public warningMessageMain            : string | undefined;
  public warningMessageSub             : string | undefined;
  public worldCardMode                 : 'countries' | 'allLocations' = 'countries';
  public zoomedCountryLevel            : number=8;
  public zoomedIn                      : number = LocationServicesZoomLevel.World;
  public zoomedInLevel                 : number=12;
  public zoomedOutLevel                : number=2;
  public zoomInOnSelection             : boolean=true;
  public zoomLevelWorld                : number = LocationServicesZoomLevel.World;

  public readonly riskLegendLevels: number[]=[5, 4, 3, 2, 1];

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.container && !this.container.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }

  constructor(
    private changeDetectorRef               : ChangeDetectorRef,
    private companiesService                : CompaniesService,
    private componentAccessUserService      : ComponentAccessUserService,
    private configSystemService             : ConfigSystemService,
    private countriesService                : CountriesService,
    private datePipe                        : DatePipe,
    private devicesService                  : DevicesService,
    private el                              : ElementRef,
    private exceptionsService               : ExceptionsService,
    private globalEventService              : GlobalEventService,
    private http                            : HttpClient,
    private locationAwarenessService        : LocationAwarenessService,
    private risklineCountryRiskLevelsService: RisklineCountryRiskLevelsService,
    private risklineSharedService           : RisklineSharedService,
    private signalsTravelRiskService        : SignalsTravelRiskService,
    private usersService                    : UsersService,
    private webbingService                  : WebbingService
  ) {
    // Define the bounds (southWest and northEast corners)
    const southWest = latLng(-85, -180);
    const northEast = latLng(85, 180);
    const bounds    = latLngBounds(southWest, northEast);

    this.activeTileLayer = tileLayer(this.locationServicesTileURL, {
      noWrap: true,
      attribution: this.locationServicesTileAttribution
    });

    this.tileLayerOptions = [
      { label: 'Default',             layer: this.activeTileLayer },
      { label: 'Google Roadmap',      layer: tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',                                                                                                                                                                                                                                          { maxZoom: 20, noWrap: true, subdomains: ['mt0','mt1','mt2','mt3'] }) },
      { label: 'Google Satellite',    layer: tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',                                                                                                                                                                                                                                          { maxZoom: 20, noWrap: true, subdomains: ['mt0','mt1','mt2','mt3'] }) },
      { label: 'Google Hybrid',       layer: tileLayer('https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',                                                                                                                                                                                                                                          { maxZoom: 20, noWrap: true, subdomains: ['mt0','mt1','mt2','mt3'] }) },
      //{ label: 'microsoft.base',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //A base map is a standard map that displays roads, natural and artificial features along with the labels for those features in a vector tile.
      //Supports zoom levels 0 through 22. Format: vector (pbf).
      //{ label: 'microsoft.base.labels',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.labels&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok',	{ maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Displays labels for roads, natural and artificial features in a vector tile.
      //Supports zoom levels 0 through 22. Format: vector (pbf).
      //{ label: 'microsoft.base.hybrid',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.hybrid&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok',	{ maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Displays road, boundary and label data in a vector tile.
      //Supports zoom levels 0 through 22. Format: vector (pbf).
      { label: 'microsoft.terra.main',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.terra.main&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 6, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Shaded relief and terra layers.
      //Supports zoom levels 0 through 6. Format: raster (png).
      { label: 'microsoft.base.road',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.road&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //All layers with our main style.
      //Supports zoom levels 0 through 22. Format: raster (png).
      { label: 'microsoft.base.darkgrey',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.darkgrey&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //All layers with our dark grey style.
      //Supports zoom levels 0 through 22. Format: raster (png).
      { label: 'microsoft.base.labels.road',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.labels.road&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Label data in our main style.
      //Supports zoom levels 0 through 22. Format: raster (png).
      { label: 'microsoft.base.labels.darkgrey',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.labels.darkgrey&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Label data in our dark grey style.
      //Supports zoom levels 0 through 22. Format: raster (png).
      { label: 'microsoft.base.hybrid.road',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.hybrid.road&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Road, boundary and label data in our main style.
      //Supports zoom levels 0 through 22. Format: raster (png).
      { label: 'microsoft.base.hybrid.darkgrey',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.base.hybrid.darkgrey&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Road, boundary and label data in our dark grey style.
      //Supports zoom levels 0 through 22. Format: raster (png).
      { label: 'microsoft.imagery',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //A combination of satellite or aerial imagery. Only available in S1 and G2 pricing SKU.
      //Supports zoom levels 1 through 19. Format: raster (png).
      { label: 'microsoft.weather.radar.main',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.weather.radar.main&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 15, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Weather radar tiles. Latest weather radar images including areas of rain, snow, ice and mixed conditions. For more information on the Azure Maps Weather service coverage, see Azure Maps weather services coverage. For more information on Radar data, see Weather services in Azure Maps.
      //Supports zoom levels 0 through 15. Format: raster (png).
      { label: 'microsoft.weather.infrared.main',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.weather.infrared.main&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 15, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //Weather infrared tiles. Latest Infrared Satellite images shows clouds by their temperature. For more information, see Azure Maps weather services coverage. For more information about the satellite data returned, see Weather services in Azure Maps.
      //Supports zoom levels 0 through 15. Format: raster (png).
      //{ label: 'microsoft.traffic.absolute',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.absolute&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //absolute traffic tiles in vector
      //{ label: 'microsoft.traffic.absolute.main',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.absolute.main&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok',	{ maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //absolute traffic tiles in raster in our main style.
      //{ label: 'microsoft.traffic.relative',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.relative&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //relative traffic tiles in vector
      //{ label: 'microsoft.traffic.relative.main',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.relative.main&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //relative traffic tiles in raster in our main style.
      //{ label: 'microsoft.traffic.relative.dark',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.relative.dark&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //relative traffic tiles in raster in our dark style.
      //{ label: 'microsoft.traffic.delay',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.delay&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //traffic tiles in vector
      //{ label: 'microsoft.traffic.delay.main',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.delay.main&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //traffic tiles in raster in our main style
      //{ label: 'microsoft.traffic.reduced.main',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.reduced.main&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //reduced traffic tiles in raster in our main style
      //{ label: 'microsoft.traffic.incident',     layer: tileLayer('https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.traffic.incident&zoom={z}&x={x}&y={y}&language=en-GB&subscription-key=1aqUa6aKDegpAFS3xEqTKT1ijTusRSkEFpbBpidmQmU9tE0ObgbAJQQJ99CDACi5YpzS4ipPAAAgAZMP2aok', { maxZoom: 19, noWrap: true, attribution: '© Microsoft Azure Maps' }) },
      //incident tiles in vector
    ];

    //this.blankCoordinate.lat = window.innerWidth >= 1930 ? 0 : 45;
    this.blankCoordinate.lat = window.innerWidth >= 1930 ? 18.5629  : 30;
    this.blankCoordinate.lng = window.innerWidth >= 1930 ? 14.6777  : 0;

    if (window.innerHeight < 900)
      this.blankCoordinate.lat = 35;

    this.mapOptions = {
      center: latLng(this.blankCoordinate.lat, 0),
      zoom: this.getInitialZoom(),
      minZoom: this.getInitialZoom(),
      maxBounds: bounds,           // Restrict view to these bounds
      maxBoundsViscosity: 1.0,     // 1.0 = fully restrict panning outside bounds
      layers: [this.activeTileLayer]
    };
  }

  public ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['iccid'] && this.iccid != undefined && !this.simDeviceLoadRequested)
        this.getSureSimDevice();

      if (changes['riskDataSourceID'] && !changes['riskDataSourceID'].firstChange && this.showRiskColouring)
        this.loadCountryRiskLevels();

      if (changes['showRiskColouring'] && !changes['showRiskColouring'].firstChange && this.showRiskColouring) {
        this.tryBuildRiskLayer();
        this.loadCountryRiskLevels();
      }

      if (changes['companyId'] && !changes['companyId'].firstChange && this.companyId != undefined) {
        this.locationSettingsLoaded = false;
        this.loadLocationSettings();

        if (this.mapOwnsCountrySelection())
          this.selectedCountryIsos=[];

        this.clearLocationData();
        this.refresh();
      }

      this.tryLoadLocationSettings();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnInit(): void {
    try {
      if (this.sidebarOpenByDefault)
        this.sidebarCollapsed=false;

      if (this.worldZoomLevel!==undefined)
        this.mapOptions={
          ...this.mapOptions,
          center : latLng(this.blankCoordinate.lat ?? 0, this.blankCoordinate.lng ?? 0),
          minZoom: this.worldZoomLevel,
          zoom   : this.worldZoomLevel
        };

      if (this.fitWorldToWidth)
        this.mapOptions={ ...this.mapOptions, zoomSnap: 0.1 };

      this.http.get('assets/countries.geo.json').subscribe({
        next: (res) => {
          this.geoData=res as FeatureCollection;
          this.tryBuildRiskLayer();
        },
        error: (err) => console.error('Error loading JSON', err)
      });

      this.locationServicesChangedSub=this.globalEventService.locationServicesChanged$.subscribe({
        next: event => {
          if (event.sourceInstanceId === this.instanceId || (event.iccid !== this.iccid && this.iccid != undefined))
            return;

          if (event.status === 'requested') {
            this.toggleInProgress=true;
          } else if (event.status === 'completed') {
            this.toggleInProgress=false;
            this.refresh();
          } else if (event.status === 'failed') {
            this.toggleInProgress=false;
          }
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.addMarkers();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      clearTimeout(this.localToastTimer);
      this.locationServicesChangedSub?.unsubscribe();
      // RBW_20260311 - Removing the map causes an error to pop up
      // if (
      // this.map) {
      //   this.map.remove();
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Filters

  public clearSelectionClick(event: Event) {
    event.stopPropagation(); // prevents reopening dropdown immediately
    this.clearSelection();
  }

  public clearLatLngClick(event: Event) {
    event.stopPropagation(); // prevents reopening dropdown immediately
    this.latLng = '';
    this.addMarkers();
  }

  public clearSelection() {
    this.searchTerm = '';
    const seen = new Set<string>();
    this.filteredItems = [...this.locationCoordinates].filter(entry => {
      if (seen.has(entry.username ?? '')) {
        return false;
      }
      seen.add(entry.username ?? '');
      return true;
    });
    this.filteredItems.sort((a, b) => (a.username ?? '').localeCompare(b.username ?? ''));
    this.showDropdown = false;
    if (this.zoomedIn == LocationServicesZoomLevel.World) {
      this.selectedUserId        = undefined;
      this.selectedCountryId     = undefined;
      this.selectedCoordinate    = undefined;
      this.selectedUserCoordinate= undefined;
      this.selectedVisitId       = undefined;
    }
    this.countryStats = this.getCountryStats(this.filteredcountrycoordinates);
    this.addMarkers();

    if (this.selectedUserId != undefined) {
      setTimeout(() => {
          var index = this.filteredcoordinates.findIndex(x => x.id == this.selectedUserId);
          this.scrollToCard(index);
        }
      , 500);
    }
  }

  //RBW_20260716 - Custom range dates are held in-memory while editing; nothing is fetched until Apply.
  public dateEndFilterChanged(selectedDate: OurDate) {
    try {
      this.filterDateEnd=selectedDate;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public dateStartFilterChanged(selectedDate: OurDate) {
    try {
      this.filterDateStart=selectedDate;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onHistoryRangeChange(range: 'last' | '24h' | '7d' | '30d' | 'custom'): void {
    try {
      if (range === 'custom') {
        this.openCustomRangeEditor();
        return;
      }

      this.historyDateRange   =range;
      this.customRangeEditing =false;
      this.customRangeApplied =false;
      this.appliedRangeLabel  ='';
      this.historySnapshot    =undefined;

      if (range === 'last') {
        this.showCurrentLocation=true;
      }
      else {
        this.showCurrentLocation=false;
        const now  = Date.now();
        const days = range === '24h' ? 1 : range === '7d' ? 7 : 30;
        this.filterDateStart=populateOurDate(this.exceptionsService, now - days * 24 * 60 * 60 * 1000);
        this.filterDateEnd  =populateOurDate(this.exceptionsService, now);
      }

      this.loadSimLocationView();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260716 - Clear stale coordinates/markers then load the appropriate SIM view (last known location vs history for the selected window)
  private loadSimLocationView(): void {
    try {
      this.loading                    = true;
      this.locationCoordinates        = [];
      this.countryLocationCoordinates = [];
      this.markersLayer?.clearLayers();

      if (this.iccid == undefined)
        return;

      if (this.showCurrentLocation) {
        this.getCurrentLocation();
        this.locationSelected(this.currentLocationData?.Id ?? 0);
      }
      else {
        this.getSIMLocations();
        this.locationSelected(0);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openCustomRangeEditor(): void {
    try {
      this.historySnapshot = {
        range  : this.historyDateRange,
        start  : this.filterDateStart,
        end    : this.filterDateEnd,
        applied: this.customRangeApplied,
        label  : this.appliedRangeLabel
      };
      this.historyDateRange  ='custom';
      this.customRangeEditing=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCustomRangeApply(): void {
    try {
      this.customRangeEditing =false;
      this.customRangeApplied =true;
      this.showCurrentLocation=false;
      this.appliedRangeLabel  =`${this.datePipe.transform(this.filterDateStart?.date, 'd MMMM, y')} - ${this.datePipe.transform(this.filterDateEnd?.date, 'd MMMM, y')}`;
      this.historySnapshot    =undefined;

      this.loadSimLocationView();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCustomRangeCancel(): void {
    try {
      this.customRangeEditing=false;

      if (this.historySnapshot != undefined) {
        this.historyDateRange  =this.historySnapshot.range;
        this.filterDateStart   =this.historySnapshot.start;
        this.filterDateEnd     =this.historySnapshot.end;
        this.customRangeApplied=this.historySnapshot.applied;
        this.appliedRangeLabel =this.historySnapshot.label;
        this.historySnapshot   =undefined;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectItem(item : coordinateDTO) {
    this.ensureLocationsSectionOpen();

    this.searchTerm = item.username ?? '';
    this.showDropdown = false;

    this.filterList();

    if ((item.countryId ?? -1) > -1) {
      this.selectedCoordinate    = item;
      this.selectedUserCoordinate= item;
      this.selectedCountryId     = item.countryId;
      this.selectedUserId        = item.id;
      if (this.zoomInOnSelection) {
        this.zoomedIn            = LocationServicesZoomLevel.User;
      }
      if (this.zoomedIn == LocationServicesZoomLevel.User) {
        this.locationSelected(this.selectedUserId ?? -1);
      } else if (this.zoomedIn == LocationServicesZoomLevel.Country) {
        this.locationSelected(this.selectedCountryId ?? -1);
      } else 
      {
        this.locationSelected(-1);   
      }
    } else {
      this.zoomedIn              = LocationServicesZoomLevel.World;
    }
  }

  //#endregion

  //#region Get Data

  private clearLocationData(): void {
    this.markersLayer?.clearLayers();
    this.riskCountBubblesLayer?.clearLayers();

    this.countryLocationCoordinates = [];
    this.locationCoordinates        = [];
    this.locationData               = [];
    this.countryStats               = [];
    this.filteredItems              = [];
    this.selectedCoordinate         = undefined;
    this.selectedCountryId          = undefined;
    this.selectedUserCoordinate     = undefined;
    this.selectedUserId             = undefined;
    this.selectedVisitId            = undefined;
  }

  private startLocationLoad(): void {
    this.pendingLocationRequests++;
    this.loading = true;
  }

  private finishLocationLoad(): void {
    this.pendingLocationRequests = Math.max(0, this.pendingLocationRequests - 1);
    if (this.pendingLocationRequests === 0) {
      this.loading = false;
    }
  }

  private companyHomeGuardPreview(): number {
    try {
      return this.excludeAtHomeTravellers ? 1 : this.locationHomeGuardView;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.locationHomeGuardView;
    }
  }

  public getCompanySIMLocations() {
    try {
      if (this.companyId==undefined)
        throw new Error("MapSimLocationsComponent - CompanyID is undefined");

      this.showCurrentLocation = false;
      this.startLocationLoad();
      this.clearLocationData();
      this.webbingService.getCompanySIMLocations(this.companyId,
                                                 this.locationAccuracyView,
                                                 this.companyHomeGuardPreview(),
                                                 this.excludeIotDevices,
                                                 this.keepKnownCountry)
            .pipe(
              catchError((error) => {
                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
              })
            )
            .subscribe({
              next: data => {
                this.processLocationData(data);
                this.finishLocationLoad();

                if (this._userSelectedDuringLoad) {
                  this._userSelectedDuringLoad=false;
                  this.addMarkers();
                  return;
                }

                if (this.openFullyZoomedOut)
                  this._suppressFitOnNextWorldZoom=true;

                this.worldZoomClick();
              },
              error: error => {
                this.finishLocationLoad();
                this.exceptionsService.handleException(new Error(error));
              }
            });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private canLoadSimLocations(): boolean {
    try {
      return this.locationServices===true
             || this.sureSimDevice?.countryOnlyVisible===true
             || this.sureSimDevice?.arrivalDetectionPlus===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private keepCountryOnlyWhenTrackingOff(data: EsimLocationDTO[]): EsimLocationDTO[] {
    try {
      if (this.locationServices===true)
        return data;

      return (data ?? []).filter(x => x?.CountryOnly === true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private getCurrentLocation() {
    try {
      if (this.canLoadSimLocations()) {
        this.loading = true;
        this.webbingService.getCurrentLocation(this.iccid ?? "", this.locationAccuracyView, this.locationHomeGuardView, this.locationTrackingView)
              .pipe(
                catchError((error) => {   
                  this.loading = false;       
                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                })
              )
              .subscribe({
                next: data => {
                    data                       = this.keepCountryOnlyWhenTrackingOff(data);
                    this.selectedUserId        = undefined;
                    this.selectedCountryId     = undefined;
                    this.selectedCoordinate    = undefined;
                    this.selectedUserCoordinate= undefined;
                    this.currentLocationData   = data[0];
                    // var currLocationCoordinates : EsimLocationDTO[] = []; 
                    // currLocationCoordinates.push(data);
                    this.processLocationData(data);
                    this.loading = false;
                    this.countryZoomClick();
                },
                error: error => {
                  this.loading = false;
                  this.exceptionsService.handleException(new Error(error));
                }
              });

        if (this.locationServices !== true)
          return;

        this.webbingService.getLiveDataByIccid(<string>this.iccid)
        .pipe(
          catchError((error) => {          
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.sureSimLiveData=data;
           },
          error: error => {
            let raiseError: boolean=true;
  
            if (error.message.includes(ErrorStrings.OriginalWebbingError)) {
              //error.message=error.message.replace(ErrorStrings.OriginalWebbingError, ErrorStrings.ReplacementWebbingError);
              raiseError=!this.suppressOriginalWebbingError;
              console.log(error.message);
            }
            
            this.eSimManagerFormCancelled.emit();
  
            if (raiseError)
              this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSIMLocations() {
    try {
      if (this.canLoadSimLocations()) {
        this.loading = true;
        this.webbingService.getSIMLocations(this.iccid ?? "", this.locationAccuracyView, this.locationHomeGuardView, this.locationTrackingView, this.filterStartMs, this.filterEndMs)
              .pipe(
                catchError((error) => {    
                  this.loading = false;      
                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                })
              )
              .subscribe({
                next: data => {
                    data                       = this.keepCountryOnlyWhenTrackingOff(data);
                    this.selectedUserId        = undefined;
                    this.selectedCountryId     = undefined;
                    this.selectedCoordinate    = undefined;
                    this.selectedUserCoordinate= undefined;
                    this.currentLocationData   = undefined;
                    this.processLocationData(data);
                    this.loading = false;
                    if (this.filteredcountrycoordinates.length == 1) {
                      this.countryZoomClick();
                    } else {
                      this.worldZoomClick();
                    }
                },
                error: error => {
                  this.loading = false;
                  this.exceptionsService.handleException(new Error(error));
                }
              });
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSureSimDevice() {
    try {
      this.simDeviceLoadRequested = true;

      this.devicesService.getByImeiIccid(this.iccid ?? "")
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimDevice    = data;
          this.locationServices = this.sureSimDevice.locationServices;
          //RBW_20260715 - Baseline the loaded tracking state so a transactional toggle only persists on Submit when it actually changed
          this.locationServicesOriginal = this.locationServices;
          this.locationTrackingDirty    = false;

          if (!this.locationServices) {
            this.locationCoordinates        = [];
            this.countryLocationCoordinates = [];
            this.loading                    = false;
          }

          this.simDeviceLoadFinished=true;
          this.tryInitialLocationLoad();
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));

          this.simDeviceLoadFinished=true;
          this.tryInitialLocationLoad();
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public processLocationData(data : EsimLocationDTO[]) {
    try {
      this.locationData               = [];
      this.markersLayer.clearLayers();
      this.countryLocationCoordinates = [];
      this.locationCoordinates        = [];
      //RBW_20260716 - New dataset: collapse any expanded location group
      this.expandedGroupKey           = undefined;
      if (data != undefined) {
        this.locationData = data;
        const visitIds = this.isVisitMode ? this.assignVisitIds(this.locationData) : [];
        this.locationData.forEach((location, index) => {
          if (typeof location.CountryLatitude !== 'number' || typeof location.CountryLongitude !== 'number') {
            return;
          }
          this.countryLocationCoordinates.push(
            {
              country                   : location.CountryName ?? location.State,
              countryFlag               : location.CountryFlagIcon, 
              countryId                 : location.CountryId,
              countryOnly               : location.CountryOnly===true,
              dateRange                 : this.datePipe.transform(location.LastUpdate, 'dd/MM HH:mm') ?? "",
              distanceFromCountryPolygon: location.DistanceFromCountryPolygon ?? 0,
              endDate                   : populateOurDate(this.exceptionsService, location.LastUpdate), 
              iccid                     : location.ICCID,
              id                        : location.CountryId,
              islandMaxLatitude         : location.IslandMaxLatitude,
              islandMaxLongitude        : location.IslandMaxLongitude,
              islandMinLatitude         : location.IslandMinLatitude,
              islandMinLongitude        : location.IslandMinLongitude,
              label                     : location.CountryName ?? location.State,
              lat                       : location.CountryLatitude,
              lng                       : location.CountryLongitude, 
              network                   : location.Network,
              parentCountryId           : location.ParentCountryId ?? undefined,
              placeName                 : location.CountryOnly===true
                                          ? (location.CountryName ?? location.State)
                                          : location.City != ''
                                            ? location.City
                                            : location.Town != ''
                                              ? location.Town
                                              : location.Village,
              simCount                  : location.CountrySimCount,
              startDate                 : populateOurDate(this.exceptionsService, location.FirstUpdate),
              username                  : location.UserName,
              visitId                   : this.isVisitMode ? visitIds[index] : undefined
            });
  
          this.locationCoordinates.push({country                   : location.CountryName ?? location.State, 
                                         countryFlag               : location.CountryFlagIcon, 
                                         countryId                 : location.CountryId, 
                                         dateRange                 : this.getDateRange(location), 
                                         distanceFromCountryPolygon: location.DistanceFromCountryPolygon ?? 0, 
                                         endDate                   : populateOurDate(this.exceptionsService, location.LastUpdate),
                                         iccid                     : location.ICCID,
                                         id                        : location.Id,
                                         islandMaxLatitude         : location.IslandMaxLatitude,
                                         islandMaxLongitude        : location.IslandMaxLongitude,
                                         islandMinLatitude         : location.IslandMinLatitude,
                                         islandMinLongitude        : location.IslandMinLongitude,
                                         label                     : this.iccid != undefined && location.CountryOnly === true
                                                                     ? (location.CountryName ?? location.State)
                                                                     : this.iccid != undefined ? location.City != ''
                                                                                               ? location.City
                                                                                               : location.Town != ''
                                                                                                 ? location.Town
                                                                                                 : location.Village
                                                                                             : `${location.UserName}<br>${location.ICCID}`, 
                                         lat                       : location.CountryOnly === true ? location.CountryLatitude  : location.Latitude,
                                         lng                       : location.CountryOnly === true ? location.CountryLongitude : location.Longitude,
                                         network                   : location.Network,
                                         parentCountryId           : location.ParentCountryId ?? undefined,
                                         placeName                 : location.CountryOnly === true ? (location.CountryName ?? location.State)
                                                                   : location.City != '' ? location.City
                                                                                         : location.Town != ''
                                                                                           ? location.Town
                                                                                           : location.Village,
                                         positionApproximate       : location.PositionApproximate === true,
                                         countryOnly               : location.CountryOnly === true,
                                         simCount                  : location.CountrySimCount,
                                         startDate                 : populateOurDate(this.exceptionsService, location.FirstUpdate),
                                         username                  : location.UserName,
                                         visitId                   : this.isVisitMode ? visitIds[index] : undefined });
        });

        this.clearSelection();
      }

      this.buildRiskCountBubbles();

      if (this.riskDisplayMode==='live')
        this.refreshRiskStyling();

      this.locationDataLoaded.emit(this.locationData ?? []);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Map

  private addMarkers(): void {
    try {
      if (!this.isMapReady() || !this.markersLayer)
        return;

      this.markersLayer.clearLayers();
      const bounds = latLngBounds([]);
      const bubblesReplacePins: boolean=this.bubblesReplacePinsNow();
      
      this.lastAggregatesReplacePins=bubblesReplacePins;

      if (this.latLng != '') {
        let parts = this.latLng.split(',');
        if (parts.length == 2) {
          let lat = Number(parts[0].trim());
          let lng = Number(parts[1].trim());
          const mark = (marker([lat, lng], {icon : iconAmber, zIndexOffset: 1000 } ) as Marker & { customId?: number })
                          .bindPopup(`<b>Specified Location'}</b>`);

                        mark.customId = -5;
                        this.markersLayer.addLayer(mark);
                        bounds.extend([lat, lng]);
        }
      }
   
      if (!bubblesReplacePins && (this.locationCoordinates.length > 0) && (this.selectedCountryId ?? 0) > -1) {
        if (this.zoomedIn != LocationServicesZoomLevel.World) {
          this.locationCoordinates.forEach(coord => {
            if (typeof coord.lat !== 'number' || typeof coord.lng !== 'number') {
              console.error('Invalid coordinate:', coord);
              return;
            }

            if (this.isVisitMode && coord.visitId != this.selectedVisitId) {
              return;
            }

            var iconZIndex = this.selectedUserCoordinate != undefined &&
                             coord.lat == this.selectedUserCoordinate.lat && 
                             coord.lng == this.selectedUserCoordinate.lng ? 1000 : 0;
            var iconToShow = this.getIcon(coord); 
            if (((coord?.countryId ?? -1) > 0 && this.showCoordinate(coord) == true)) {
              const mark = (marker([coord.lat, coord.lng], {icon : iconToShow, zIndexOffset: iconZIndex } ) as Marker & { customId?: number })
                .bindPopup(`<b>${coord.label || 'Location'}</b>`);

              mark.customId = coord.id;
              this.markersLayer.addLayer(mark);
              bounds.extend([coord.lat, coord.lng]);
              mark.on('click', this.onMarkerClick);
            }
          });
        } else {
          const worldCoords = this.showAllLocationCards
                              ? this.filteredcoordinates
                              : (this.isVisitMode ? this.filteredcoordinates : this.countryLocationCoordinates)
                                  .filter(c => this.expandedGroupKey == undefined || this.groupKey(c) !== this.expandedGroupKey)
                                  .concat(this.childrenForExpandedGroup());
          worldCoords.forEach(coord => {
            if (typeof coord.lat !== 'number' || typeof coord.lng !== 'number') {
              console.error('Invalid coordinate:', coord);
              return;
            }

            var isSelected = this.showAllLocationCards ? (this.selectedUserCoordinate != undefined && coord.id == this.selectedUserCoordinate.id)
                           : this.isVisitMode          ? (coord.visitId == this.selectedVisitId || coord.id == this.selectedUserId || (this.selectedCountryId != undefined && (coord.countryId ?? -2) == this.selectedCountryId))
                           :                              (coord.id == this.selectedCountryId || coord.id == this.selectedUserId);
            var iconZIndex = isSelected ? 1000 : 0;
            var iconToShow = isSelected ? iconGreen : iconGrey;
            if (((coord?.countryId ?? -1) > 0 && this.showCoordinate(coord) == true)) {
              const mark = (marker([coord.lat, coord.lng], {icon : iconToShow, zIndexOffset: iconZIndex } ) as Marker & { customId?: number })
                .bindPopup(`<b>${coord.label || 'Location'}</b>`);

              mark.customId = this.showAllLocationCards ? (coord.id ?? -1) : this.isVisitMode ? (coord.visitId ?? -1) : coord.id;
              this.markersLayer.addLayer(mark);
              bounds.extend([coord.lat, coord.lng]);
              mark.on('click', this.onMarkerClick);
            }
          });
        }
      } 
  
      if (!this.zoomInOnSelection && this.isMapReady() && !this.showAllLocationCards) {
        if (this.selectedUserCoordinate != undefined && this.hasUsableFix(this.selectedUserCoordinate)) {
          this.map.setView([this.selectedUserCoordinate.lat ?? 0, this.selectedUserCoordinate.lng ?? 0], this.map.getZoom()); // Instant jump
        }
      }
      setTimeout(() => { this.map?.invalidateSize(); });

      this.buildRiskCountBubbles();

      if (this.bubblesReplacePinsNow())
        this.markersLayer?.clearLayers();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

 public colourMap(map: Map) {
    const resetHighlight=(e : any) => {
      this.geoJsonLayer?.resetStyle(e.target);
      this.countryHovered.emit(undefined);
    }

    function getColor(d : any) {
      return d > 100000000
        ? "#800026"  //800026
        : d > 80000000
        ? "#BD0026"
        : d > 50000000
        ? "#E31A1C"
        : d > 10000000
        ? "#FC4E2A"
        : d > 1000000
        ? "#FD8D3C"
        : d > 1000000
        ? "#FEB24C"
        : d > 100000
        ? "#FED976"
        : "blue";
    }

    const style=(feature : any) => {
      if (this.showRiskColouring)
        return this.riskLayerStyle(feature);

      return {
        weight: 2,
        opacity: 1,
        color: "white",
        dashArray: "3",
        // fillOpacity: 0.7,
        // fillColor: getColor(feature.properties.pop_est)
      };
    }

    //RBW_20261002 - The coarse outlines of large countries (Malaysia, Italy, France ...) completely cover small countries inside them (Singapore, Vatican, Monaco ...).
    //Raising the hovered country would bury those small countries, and they can only be reached from inside it, so re-raise any country lying within its bounds
    const bringFeatureToFront=(layer : any) => {
      layer.bringToFront();

      const bounds=layer.getBounds();

      this.geoJsonLayer?.eachLayer((other : any) => {
        if (other!==layer && bounds.contains(other.getBounds()))
          other.bringToFront();
      });
    }

    const highlightFeature=(e : any) => {
      var layer = e.target;

      this.countryHovered.emit(this.getFeatureIsoCode(layer?.feature));
      this.applyCountryTooltipForHover(layer);

      if (this.showRiskColouring) {
        const riskColour: string | undefined=this.getRiskFillColour(layer?.feature);
        const zoomedOut : boolean           =this.isRiskFillZoom();

        layer.setStyle({
          color      : '#666666',
          dashArray  : '',
          fillColor  : riskColour ?? 'transparent',
          fillOpacity: (riskColour!=undefined && zoomedOut) ? 1.0 : 0,
          weight     : 2
        });

        if (!Browser.ie && !Browser.opera && !Browser.edge)
          bringFeatureToFront(layer);

        return;
      }

      if (layer._map._zoom < 8) {
        layer.setStyle({
          weight: 5,
          color: "#666",
          dashArray: "",
          fillOpacity: 0.7
        });
      } else {
          layer.setStyle({
          weight: 5,
          color: "#666",
          dashArray: "",
          fillOpacity: 0
        });   
      }

      if (!Browser.ie && !Browser.opera && !Browser.edge) {
        bringFeatureToFront(layer);
      }
    }

    const onEachFeature = (feature : any, layer : any) => {
      layer.on({
  //      click: this.showInfo,
        mouseover: highlightFeature,
        mouseout: resetHighlight
      });

      if (this.showRiskColouring || this.intendsRiskColouring)
        layer.trmTooltipLabel=this.getFeatureTooltipLabel(feature);
    };

    const geojson = geoJSON(this.geoData, {
      style: style,
      onEachFeature: onEachFeature
    }).addTo(map);
    this.geoJsonLayer  = geojson;

    if (this.showRiskColouring || this.intendsRiskColouring) {
      map.off('zoomstart', this.onMapZoomEndForRisk);
      map.off('zoomend'  , this.onMapZoomEndForRisk);
      map.on ('zoomstart', this.onMapZoomEndForRisk);
      map.on ('zoomend'  , this.onMapZoomEndForRisk);
    }

    if (this.showRiskColouring) {
      this.loadCountryRiskLevels();
      this.refreshRiskStyling();
    }
  }

  private onMapZoomEndForRisk=(): void => {
    try {
      this.refreshRiskStyling();

      if (!this.showRiskColouring)
        return;
      
      this.setBubbleSizeForZoom();

      const swapped   : boolean=this.applyZoomPinSwap();
      const replaceNow: boolean=this.bubblesReplacePinsNow();

      if (!swapped && replaceNow===this.lastAggregatesReplacePins)
        return;

      this.addMarkers();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  public addLatLng() {
    if (this.latLng != '') {
      this.addMarkers();
    }
  }

  public filterList() {
    this.countryStats = this.getCountryStats(this.filteredcountrycoordinates); 
    const seen = new Set<string>();
    const term = this.searchTerm.toLowerCase();

    this.filteredItems = [...this.locationCoordinates].filter(item =>
          (item.username ?? '').toLowerCase().includes(term)
        ).filter(entry => {
      if (seen.has(entry.username ?? '')) {
        return false;
      }
      seen.add(entry.username ?? '');
      return true;
    });

    this.filteredItems.sort((a, b) => (a.username ?? '').localeCompare(b.username ?? ''));
    this.addMarkers();
  }

  public getCardColour(coordinate : coordinateDTO) {
    if (this.showAllLocationCards) {
      return (this.selectedUserCoordinate != undefined && coordinate.id == this.selectedUserCoordinate.id) ? '#b0e7b8' : '#ffffff';
    }

    if (this.selectedUserCoordinate != undefined && coordinate.id === this.selectedUserCoordinate.id && (coordinate.countryId ?? -1) > -1) {
      return '#b0e7b8';
    }

    if (this.isCountryAccuracyView() && this.selectedCountryId != undefined && (coordinate.countryId ?? -2) === this.selectedCountryId && (coordinate.countryId ?? -1) > -1) {
      return '#b0e7b8';
    }

    if (this.isVisitMode && this.zoomedIn == LocationServicesZoomLevel.World) {
      //RBW_20260716 - A country's pin is shared by all its visits, so selecting it (selectedCountryId) highlights every visit card for that country
      return ((coordinate.visitId != undefined && coordinate.visitId == this.selectedVisitId) ||
              (this.selectedCountryId != undefined && (coordinate.countryId ?? -2) == this.selectedCountryId)) ? '#b0e7b8' : '#ffffff';
    }
    return (((coordinate.id == (this.selectedUserCoordinate?.id ?? 0)) ||
             (coordinate.id == coordinate.countryId && coordinate.id == this.selectedCountryId && this.zoomedIn == LocationServicesZoomLevel.World)) &&
            ((coordinate.countryId ?? -1) > -1)) ? '#b0e7b8' : '#ffffff'
  }

  private findMarker(id: number): Marker | undefined {
    let foundMarker: Marker | null = null;

    this.markersLayer.eachLayer((layer) => {
      const marker = layer as Marker & { customId?: number };
      if (marker.customId === id) {
        foundMarker = marker;
      }
    });

    if (foundMarker) {
      return foundMarker;
    } 
    return undefined;
  }

  // public showInfo(e : any) {
  //     var layer = e.target;
  //     //console.log('Country Clicked', layer.feature.properties.name);
  // }

  public getCountryDateRange(coord : coordinateDTO) {
    var stat = this.getStatForCoord(coord);
    if (stat?.maxDate == undefined) {
      return '';
    }
    //var prefix = this.showCurrentLocation ? 'Updated: ' : '';
    if (stat?.simCount == 1) {
      var prefix = 'Updated: ';
      return prefix + (this.datePipe.transform(stat?.maxDate?.date, 'dd/MM HH:mm') ?? "");
    }
    return (this.datePipe.transform(stat?.minDate?.date, 'dd/MM HH:mm') ?? "") + '-' + (this.datePipe.transform(stat?.maxDate?.date, 'dd/MM HH:mm') ?? "");
  }

  public getCountrySimCount(coord : coordinateDTO) {
    var stat = this.getStatForCoord(coord);
    return stat?.simCount ?? 0;
  }

  public getHomeGuardDateRange(coord : coordinateDTO) {
    if (coord.endDate == undefined) {
      return '';
    }
    var first = this.datePipe.transform(coord.startDate?.date, 'dd/MM HH:mm') ?? "";
    var last  = this.datePipe.transform(coord.endDate?.date,   'dd/MM HH:mm') ?? "";
    return first + '-' + last;
  }

  //#region CRN_20260903 - Country risk colouring (Travel Risk Management only)

  private static readonly isoOverridesByGeoName: Record<string, string>={
    'Kosovo'     : 'XK',
    'N. Cyprus'  : 'CY',
    'Somaliland' : 'SO'
  };

  private static readonly awaitingColourFill    : string='#d9dee3';
  private static readonly bubbleGrowthPerZoom   : number=3;
  private static readonly bubbleSizeMaxPx       : number=48;
  private static readonly bubbleSizePx          : number=26;
  private static readonly countryOutlineUnfilled: string='#6c757d';
  private static readonly fitWorldCentreLat     : number=18.5629;
  private static readonly fitWorldCentreLng     : number=14.6777;
  private static readonly fitWorldVisibleWidth  : number=0.8;
  private static readonly notAssessedColour     : string='#adb5bd';
  private static readonly riskFillMaxZoom       : number=4;
  private static readonly sidebarSlideMs        : number=250;

  private getFeatureIsoCode(feature: any): string | undefined {
    try {
      const rawIso: string=(feature?.properties?.iso_a2 ?? '').toString().toUpperCase();

      if (rawIso!=='' && rawIso!=='-99')
        return rawIso;

      const geoName: string=(feature?.properties?.name ?? '').toString();

      return MapSimLocationsComponent.isoOverridesByGeoName[geoName];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private applyCountryTooltipForHover(layer: any): void {
    try {
      if (layer==undefined)
        return;

      const label: string=<string>(layer.trmTooltipLabel ?? '');

      if (label==='')
        return;

      const wanted: boolean=this.showRiskColouring && this.isRiskFillZoom();
      const bound : boolean=layer.getTooltip!=undefined && layer.getTooltip()!=undefined;

      if (wanted && !bound) {
        layer.bindTooltip(label, { direction: 'top', sticky: true });
        layer.openTooltip?.();
      }
      else if (!wanted && bound)
        layer.unbindTooltip();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getFeatureTooltipLabel(feature: any): string {
    try {
      const name: string=(feature?.properties?.name_long
                          ?? feature?.properties?.name
                          ?? '').toString().trim();

      const iso : string | undefined=this.getFeatureIsoCode(feature);

      if (name==='')
        return iso ?? '';

      return iso!=undefined ? name + ' (' + iso + ')' : name;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private hasTravellersInCountry(isoCode: string): boolean {
    try {
      const target: string=(isoCode ?? '').toUpperCase();

      if (target==='')
        return false;

      return (this.filteredcountrycoordinates ?? []).some(coord => {
        const countryId: number=coord?.countryId ?? -1;

        if (countryId<=0 || this.getCountryTravellerCount(coord)<=0)
          return false;

        return this.getIsoCodeForCountryId(countryId, coord?.parentCountryId)?.toUpperCase()===target;
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private getRiskFillColour(feature: any): string | undefined {
    try {
      const iso: string | undefined=this.getFeatureIsoCode(feature);

      if (iso==undefined)
        return undefined;

      if (this.riskDisplayMode==='live' && !this.hasTravellersInCountry(iso))
        return undefined;

      const riskLevelId: number | undefined=this.riskLevelByIso[iso];

      if (riskLevelId==undefined)
        return undefined;

      return this.risklineSharedService.getRiskLevelHexColour(riskLevelId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public getRiskLegendColour(riskLevelId: number): string {
    try {
      return this.risklineSharedService.getRiskLevelHexColour(riskLevelId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '#878a99';
    }
  }

  public getRiskLegendLabel(riskLevelId: number): string {
    try {
      return this.risklineSharedService.getRiskLevelLabel(riskLevelId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'Unknown';
    }
  }

  private onCountryBubbleClick=(iso: string, event: MouseEvent): void => {
    try {
      if (!this.countrySelectionAllowed() || iso=='')
        return;

      event.preventDefault();
      event.stopPropagation();

      const additive : boolean=event.ctrlKey || event.metaKey;
      const isSelected: boolean=this.selectedCountryIsos.indexOf(iso)>=0;

      if (additive)
        this.selectedCountryIsos=isSelected
                                 ? this.selectedCountryIsos.filter(code => code!=iso)
                                 : this.selectedCountryIsos.concat([iso]);
      else
        this.selectedCountryIsos=(isSelected && this.selectedCountryIsos.length==1) ? [] : [iso];

      this.applyBubbleSelectionStyling();
      this.countrySelectionChanged.emit(this.selectedCountryIsos.slice());

      if (this.mapOwnsCountrySelection())
        this.changeDetectorRef.detectChanges();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  private countrySelectionAllowed(): boolean {
    try {
      return this.enableCountrySelection || this.filterListToCountrySelection;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private mapOwnsCountrySelection(): boolean {
    try {
      return this.filterListToCountrySelection && !this.enableCountrySelection;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private applyBubbleSelectionStyling(): void {
    try {
      const hasSelection: boolean=this.selectedCountryIsos.length>0;

      this.riskCountBubblesLayer?.eachLayer((layer: any) => {
        const element: HTMLElement | undefined=layer?.getElement?.();
        const iso    : string                 =(layer?.options?.countryIsoCode ?? '').toString();

        if (element==undefined)
          return;

        const isSelected: boolean=hasSelection && this.selectedCountryIsos.indexOf(iso)>=0;

        element.classList.toggle('risk-count-bubble-dulled',   hasSelection && !isSelected);
        element.classList.toggle('risk-count-bubble-selected', isSelected);
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearCountrySelection(): void {
    try {
      if (this.selectedCountryIsos.length==0)
        return;

      this.selectedCountryIsos=[];
      this.applyBubbleSelectionStyling();
      this.countrySelectionChanged.emit([]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setCountrySelection(isoCodes: string[]): void {
    try {
      this.selectedCountryIsos=(isoCodes ?? []).map(iso => (iso ?? '').trim().toUpperCase())
                                               .filter(iso => iso!='');

      this.applyBubbleSelectionStyling();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyZoomPinSwap(): boolean {
    try {
      if (!this.showRiskColouring || !this.enableCountrySelection)
        return false;

      if (this.riskDisplayMode==='risk')
        return false;

      const zoomedOut: boolean=this.isZoomedOutForAggregates();

      if (!zoomedOut && this.showCountBubbles) {
        this.showCountBubbles        =false;
        this.bubblesAutoSwappedToPins=true;
        return true;
      }

      if (zoomedOut && this.bubblesAutoSwappedToPins) {
        this.showCountBubbles        =true;
        this.bubblesAutoSwappedToPins=false;
        return true;
      }

      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private bubbleSizeForZoom(): number {
    try {
      const zoom   : number=this.map?.getZoom() ?? this.zoomedOutLevel;
      const stepsIn: number=Math.max(0, zoom-this.zoomedOutLevel);
      const sized  : number=MapSimLocationsComponent.bubbleSizePx
                            +(stepsIn*MapSimLocationsComponent.bubbleGrowthPerZoom);

      return Math.min(sized, MapSimLocationsComponent.bubbleSizeMaxPx);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return MapSimLocationsComponent.bubbleSizePx;
    }
  }

  private setBubbleSizeForZoom(): void {
    try {
      if (!this.isMapReady())
        return;

      const size: number=this.bubbleSizeForZoom();

      this.map.getContainer()?.style.setProperty('--risk-bubble-size', size + 'px');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildRiskCountBubbles(): void {
    try {
      if (!this.showRiskColouring || this.map==undefined)
        return;

      this.setBubbleSizeForZoom();

      if (this.riskCountBubblesLayer==undefined)
        this.riskCountBubblesLayer=layerGroup().addTo(this.map);

      this.riskCountBubblesLayer.clearLayers();

      if (!this.bubblesReplacePinsNow())
        return;

      const seenCountryIds: Record<number, boolean>={};

      (this.filteredcountrycoordinates ?? []).forEach(coord => {
        const countryId: number=coord?.countryId ?? -1;

        if (countryId<=0 || seenCountryIds[countryId])
          return;

        if (typeof coord.lat!=='number' || typeof coord.lng!=='number')
          return;

        const count: number=this.getCountryTravellerCount(coord);

        if (count<=0)
          return;

        seenCountryIds[countryId]=true;

        const iso    : string | undefined=this.getIsoCodeForCountryId(countryId, coord?.parentCountryId);
        const colour : string            =iso!=undefined && this.riskLevelByIso[iso]!=undefined
                                          ? this.risklineSharedService.getRiskLevelHexColour(this.riskLevelByIso[iso])
                                          : MapSimLocationsComponent.notAssessedColour;
        const countryName: string        =(coord.country ?? '').replace(/</g, '&lt;');
        const label      : string        =iso!=undefined ? countryName + ' (' + iso + ')' : countryName;
        const selectable  : boolean=this.countrySelectionAllowed() && iso!=undefined;
        const wrapperClass: string ='risk-count-bubble-wrapper' + (selectable ? ' risk-count-bubble-clickable' : '');
        const tooltipHint : string =selectable
                                    ? '<br><small>Click to filter, Ctrl+click to add</small>'
                                    : (this.countrySelectionAllowed() ? '<br><small>No country code, cannot filter</small>' : '');

        const bubble=marker([coord.lat, coord.lng], {
          icon: divIcon({
            className: wrapperClass,
            html     : '<span class="risk-count-bubble" style="background:' + colour + '">' + count + '</span>',
            iconSize : [MapSimLocationsComponent.bubbleSizePx, MapSimLocationsComponent.bubbleSizePx]
          }),
          countryIsoCode: iso ?? '',
          zIndexOffset  : 400
        } as any).bindTooltip(label + ': ' + count + (count===1 ? ' traveller' : ' travellers') + tooltipHint);

        if (selectable)
          bubble.on('click', (event: any) => this.onCountryBubbleClick(<string>iso, <MouseEvent>event?.originalEvent));

        this.riskCountBubblesLayer?.addLayer(bubble);
      });

      this.applyBubbleSelectionStyling();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public isShowingCountBubbles(): boolean {
    try {
      return this.showCountBubblesEffective();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private showCountBubblesEffective(): boolean {
    try {
      return this.showCountBubbles;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private isZoomedOutForAggregates(): boolean {
    try {
      return (this.map?.getZoom() ?? 2)<MapSimLocationsComponent.riskFillMaxZoom;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private bubblesReplacePinsNow(): boolean {
    try {
      if (!this.showRiskColouring)
        return false;

      if (this.enableCountrySelection)
        return this.showCountBubblesEffective();

      return this.showCountBubblesEffective() && this.aggregatesReplacePins();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private aggregatesReplacePins(): boolean {
    try {
      return this.riskDisplayMode==='risk' || this.isZoomedOutForAggregates();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private updateRiskLegendVisibility(): void {
    try {
      this.riskLegendElement?.classList.toggle('d-none', !this.isRiskFillZoom());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private isRiskFillZoom(): boolean {
    try {
      if (this.riskDisplayMode==='risk')
        return true;

      if (this.riskDisplayMode==='map')
        return false;

      return (this.map?.getZoom() ?? 2)<MapSimLocationsComponent.riskFillMaxZoom;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private getCountryTravellerCount(coord: coordinateDTO): number {
    try {
      if (coord?.simCount!=undefined && coord.simCount>0)
        return coord.simCount;

      return this.countryStats.find(stat => stat.countryId===(coord?.countryId ?? -1))?.simCount ?? 0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 0;
    }
  }

  private applyCountrySelectionToList(coords: coordinateDTO[]): coordinateDTO[] {
    try {
      if (!this.filterListToCountrySelection || this.selectedCountryIsos.length==0)
        return coords;

      return coords.filter(coordinate => {
        const iso: string | undefined=this.getIsoCodeForCountryId(<number>coordinate.countryId, coordinate?.parentCountryId);

        return iso!=undefined && this.selectedCountryIsos.indexOf(iso)>=0;
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return coords;
    }
  }

  private getIsoCodeForCountryId(countryId: number, parentCountryId?: number): string | undefined {
    try {
      const match=this.countriesService.allCountries?.find(country => country.id===countryId);

      if (match?.alpha2Code!=undefined)
        return match.alpha2Code.toUpperCase();

      if (parentCountryId==undefined)
        return undefined;

      return this.countriesService.allCountries
                 ?.find(country => country.id===parentCountryId)?.alpha2Code?.toUpperCase();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private tryBuildRiskLayer(): void {
    try {
      if (!this.showRiskColouring && !this.intendsRiskColouring)
        return;

      if (this.map==undefined || this.geoData==undefined)
        return;

      if (this.geoJsonLayer==undefined)
        this.colourMap(this.map);
      else
        this.refreshRiskStyling();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadRisklineCountryRiskLevels(): void {
    try {
      this.risklineCountryRiskLevelsService.getAllRiskLevels()
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
            })
          )
          .subscribe({
            next : (levels: CountryRiskLevelDTO[]) => {
              const byIso: Record<string, number>={};

              (levels ?? []).forEach(level => {
                const iso: string=(level?.countryIsoCode ?? '').toUpperCase();

                if (iso!=='' && level?.riskLevelID!=undefined && level?.riskLevelID!==null)
                  byIso[iso]=<number>level.riskLevelID;
              });

              this.riskLevelByIso=byIso;

              this.refreshRiskStyling();
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadSignalsCountryRiskLevels(): void {
    try {
      this.signalsTravelRiskService.getCountryLevels()
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
            })
          )
          .subscribe({
            next : (levels: TravelRiskCountryLevelDTO[]) => {
              const byIso: Record<string, number>={};

              (levels ?? []).forEach(level => {
                const iso: string=(level?.countryIsoCode ?? '').toUpperCase();

                if (iso!=='' && level?.riskLevelID!=undefined && level?.riskLevelID!==null)
                  byIso[iso]=<number>level.riskLevelID;
              });

              this.riskLevelByIso=byIso;

              this.refreshRiskStyling();
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadCountryRiskLevels(): void {
    try {
      if (!this.showRiskColouring)
        return;

      if ((this.countriesService.allCountries?.length ?? 0)==0) {
        this.countriesService.get().subscribe({
          next : list  => {
            this.countriesService.allCountries=list;
            this.buildRiskCountBubbles();
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
            this.buildRiskCountBubbles();
          }
        });
      }
      else
        this.buildRiskCountBubbles();

      if (this.riskDataSourceID===eTravelRiskDataProvider.Riskline)
        this.loadRisklineCountryRiskLevels();
      else
        this.loadSignalsCountryRiskLevels();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshRiskStyling(): void {
    try {
      this.updateRiskLegendVisibility();

      if ((!this.showRiskColouring && !this.intendsRiskColouring) || this.geoJsonLayer==undefined)
        return;

      this.geoJsonLayer.setStyle((feature: any) => this.riskLayerStyle(feature));

      this.updateTileVisibilityForZoom();
      this.buildRiskCountBubbles();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private riskLayerStyle(feature: any): any {
    try {
      const colour: string | undefined=this.getRiskFillColour(feature);
      const filled: boolean           =colour!=undefined && this.isRiskFillZoom();

      if (!filled && this.intendsRiskColouring && !this.showRiskColouring && this.isRiskFillZoom())
        return {
          color      : MapSimLocationsComponent.countryOutlineUnfilled,
          dashArray  : '',
          fillColor  : MapSimLocationsComponent.awaitingColourFill,
          fillOpacity: 1,
          weight     : 1
        };

      return {
        color      : filled ? '#ffffff' : MapSimLocationsComponent.countryOutlineUnfilled,
        dashArray  : filled ? ''          : '3',
        fillColor  : colour ?? 'transparent',
        fillOpacity: filled ? 0.9 : 0,
        weight     : filled ? 1 : 2
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return { fillOpacity: 0, weight: 2 };
    }
  }

  private startsRiskFilled(): boolean {
    try {
      if (!this.showRiskColouring && !this.intendsRiskColouring)
        return false;

      if (this.riskDisplayMode==='risk')
        return true;

      if (this.riskDisplayMode==='map')
        return false;

      return this.getInitialZoom()<MapSimLocationsComponent.riskFillMaxZoom;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private updateTileVisibilityForZoom(): void {
    try {
      if ((!this.showRiskColouring && !this.intendsRiskColouring) || this.map==undefined || this.activeTileLayer==undefined)
        return;

      const showRiskFill: boolean=this.isRiskFillZoom();

      if (showRiskFill && this.map.hasLayer(this.activeTileLayer))
        this.map.removeLayer(this.activeTileLayer);
      else if (!showRiskFill && !this.map.hasLayer(this.activeTileLayer))
        this.activeTileLayer.addTo(this.map);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public getCountryStats(data: coordinateDTO[]) {
    const grouped: Record<number, coordinateDTO[]> = {};

    for (const record of data) {
      const key = this.isVisitMode ? (record.visitId ?? -1) : (record.countryId ?? -1);
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(record);
    }

    const result = Object.entries(grouped).map(([, groupRecords]) => {
      const countryId = groupRecords[0].countryId ?? -1;
      const visitId   = groupRecords[0].visitId;
      const dates = groupRecords
        .map(r => new Date(r.endDate?.date ?? ''))
        .filter(d => !isNaN(d.getTime())); // remove invalid dates

      if (dates.length === 0) {
        return { countryId, minDate: undefined, maxDate: undefined, simCount: 0, visitId };
      }

      const minDate  = new Date(Math.min(...dates.map(d => d.getTime())));
      const maxDate  = new Date(Math.max(...dates.map(d => d.getTime())));
      const simCount = dates.length;

      return {
        countryId,
        maxDate  : populateOurDate(this.exceptionsService, maxDate),
        minDate  : populateOurDate(this.exceptionsService, minDate),
        simCount,
        visitId
      };
    });

    return result;
  }

  private getStatForCoord(coord: coordinateDTO) {
    return this.isVisitMode
      ? this.countryStats.find(x => x.visitId == (coord.visitId ?? -1))
      : this.countryStats.find(x => x.countryId == (coord.countryId ?? -1));
  }

  private getVisitMaxTime(coord: coordinateDTO): number {
    return this.getStatForCoord(coord)?.maxDate?.date.getTime() ?? 0;
  }

  private assignVisitIds(data: EsimLocationDTO[]): number[] {
    const order = data
      .map((d, i) => {
        const time = new Date(d.FirstUpdate ?? d.LastUpdate).getTime();
        return { i, countryId: d.CountryId, time: isNaN(time) ? 0 : time };
      })
      .sort((a, b) => a.time - b.time);

    const visitIds  = new Array<number>(data.length);
    let   visit       = 0;
    let   prevCountry : number | undefined = undefined;

    for (const o of order) {
      if (prevCountry === undefined || o.countryId !== prevCountry) {
        visit++;
      }
      visitIds[o.i] = visit;
      prevCountry   = o.countryId;
    }

    return visitIds;
  }

  public getDateRange(location : EsimLocationDTO) {
    if (location.LastUpdate == undefined) {
      return '';
    }
    if (location.CountryId < -100000 && this.isVisitMode) {
          return (this.datePipe.transform(location?.FirstUpdate, 'dd/MM HH:mm') ?? "") + '-' + (this.datePipe.transform(location?.LastUpdate, 'dd/MM HH:mm') ?? "");
    }
    var prefix = 'Updated: ';
    return prefix + (this.datePipe.transform(location.LastUpdate, 'dd/MM HH:mm') ?? "");
    // var prefix = this.showCurrentLocation ? 'Updated: ' : '';
    // if (location.FirstUpdate == location.LastUpdate) {
    //   return prefix + (this.datePipe.transform(location.LastUpdate, 'dd/MM HH:mm') ?? "");
    // }
    // return (this.datePipe.transform(location.FirstUpdate, 'dd/MM HH:mm') ?? "") + '-' +
    //        (this.datePipe.transform(location.LastUpdate,  'dd/MM HH:mm') ?? "")
  }

  private isMapReady(): boolean {
    try {
      const pane=this.map?.getPane('mapPane');
      
      return !!pane && (pane as any)['_leaflet_pos'] !== undefined;
    }
    catch(e) {
      return false;
    }
  }

  private getIcon(coord: coordinateDTO): Icon<IconOptions> {
     return this.selectedUserCoordinate != undefined &&
                 coord.lat == this.selectedUserCoordinate.lat &&
                 coord.lng == this.selectedUserCoordinate.lng ? iconGreen : iconGrey;
  }

  public locationSelected(id: number, forceZoom: boolean = false): void {
    try {
      var cord = this.filteredcoordinates.findIndex(x => x.id == id);
      this.selectedCoordinate = this.filteredcoordinates[cord];

      if (this.selectedCoordinate == undefined) {
        if (this.locationCoordinates.length > 0) {
          cord = this.countryLocationCoordinates.findIndex(x => x.id == id);
          this.selectedCoordinate = this.countryLocationCoordinates[cord];
        }
      }

      if (this.isMapReady() && this.selectedCoordinate != undefined) {
        if (this.zoomedIn==LocationServicesZoomLevel.World) {
          if (this.countryStats.length == 1) {
            this.map.setView([this.selectedCoordinate.lat ?? 0, this.selectedCoordinate.lng ?? 0], this.getInitialZoom()); // Instant jump
          } else {
            this.map.setView([this.blankCoordinate.lat ?? 0, this.blankCoordinate.lng ?? 0], this.getInitialZoom()); // Instant jump
          }
        }
        //RBW_20260716 - Auto-zoom on selection is gated solely by the zoomInOnSelection switch. When it is off we do NOT zoom in on any selection
        //               (including drilling into a country group card), even for internal forceZoom callers - the switch is authoritative.
        else if (this.zoomInOnSelection) {
          if (this.zoomedIn==LocationServicesZoomLevel.Country) {
            this.zoomToCountry(this.selectedCoordinate);
          } else {
            this.map.setView([this.selectedCoordinate.lat ?? 0, this.selectedCoordinate.lng ?? 0], this.zoomedInLevel); // Instant jump
          }
        }
      }
      else if (this.isMapReady()) {
        if (this.zoomedIn==LocationServicesZoomLevel.World) {
          if (this.currentLocationData != null) {
            this.map.setView([this.currentLocationData.Latitude ?? 0, this.currentLocationData.Longitude ?? 0], this.getInitialZoom()); // Instant jump
          } else if (this.countryStats.length == 1 && this.countryLocationCoordinates.length > 0) {
            this.map.setView([this.countryLocationCoordinates[0].lat ?? 0, this.countryLocationCoordinates[0].lng ?? 0], this.getInitialZoom()); // Instant jump
          } else {
            this.map.setView([this.blankCoordinate.lat ?? 0, this.blankCoordinate.lng ?? 0], this.getInitialZoom()); // Instant jump
          }
        }
      }

      this.addMarkers();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onMapReady(map: Map): void {
    try {
      this._initialLocationLoadDone=false;
      this._initialLoadRetryCount  =0;
      this.map                     =map;

      this.map.attributionControl.setPrefix(false);
      this.markersLayer = layerGroup().addTo(this.map);
      if (this.iccid != undefined) {
        if (!this.simDeviceLoadRequested)
          this.getSureSimDevice();
      }
      else if (this.companyId != undefined) {
        this.locationServices = true;
      }

      this.tryLoadLocationSettings();

      if (this.intendsRiskColouring && this.startsRiskFilled() && this.map.hasLayer(this.activeTileLayer))
        this.map.removeLayer(this.activeTileLayer);

      this.tryBuildRiskLayer();

      if (this.fitWorldToWidth) {
        this.applyFitWorldView(true);
        this.map.off('resize', this.onMapResizeForFitWorld);
        this.map.on ('resize', this.onMapResizeForFitWorld);
      }

      setTimeout(() => {
        if (this.isMapReady() && this.selectedUserId == undefined && this.selectedCountryId == undefined && this.expandedGroupKey == undefined) {
          this.map.setView([this.blankCoordinate.lat ?? 0, this.blankCoordinate.lng ?? 0], this.getInitialZoom()); // Instant jump
        }
        this.tryInitialLocationLoad();
      }, 1000);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private tryInitialLocationLoad(): void {
    try {
      if (this._initialLocationLoadDone) return;

      if (!this.isMapReady()) {
        if (!this._initialLoadRetryPending && this._initialLoadRetryCount<20) {
          this._initialLoadRetryPending=true;
          this._initialLoadRetryCount++;

          setTimeout(() => {
            this._initialLoadRetryPending = false;
            this.tryInitialLocationLoad();
          }, 500);
        }

        return;
      }

      // In SIM mode wait until the device (and therefore locationServices) is known before fetching
      if (this.iccid != undefined && this.locationServices == undefined) return;

      if (this.iccid != undefined && !this.simDeviceLoadFinished)
        return;

      this._initialLocationLoadDone = true;
      this.refresh();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refresh() {
    try {
      if (this.isMapReady()) {
        this.map.invalidateSize();
        if (this.companyId != undefined) {
          this.getCompanySIMLocations();
        } else if (this.iccid != undefined){
         if (this.showCurrentLocation) {
           this.getCurrentLocation();
         } else {
           this.getSIMLocations();
         }
        } 
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private onMarkerClick = (event: L.LeafletMouseEvent) => {
    try {
      this.ensureLocationsSectionOpen();

      const { lat, lng } = event.latlng;

      if (this.zoomedIn == LocationServicesZoomLevel.World) {
        //RBW_20260716 - An expanded group renders its individual location pins; clicking one selects that child location (works in both company and visit grouping)
        if (this.expandedGroupKey != undefined) {
          const child = this.childrenForExpandedGroup().find(x => x.lat == lat && x.lng == lng);
          if (child != undefined) {
            this.selectLocationCard(child, true);
            return;
          }
        }

        if (this.showAllLocationCards) {
          const pin = this.filteredcoordinates.find(x => x.lat == lat && x.lng == lng);
          if (pin != undefined) {
            this.selectedUserId         = pin.id;
            this.selectedUserCoordinate = pin;
            this.scrollToCard(this.filteredcoordinates.findIndex(x => x.id == pin.id));
            this.addMarkers();
          }
          return;
        }
        if (this.isVisitMode) {
          //RBW_20260716 - Every visit to a country shares the same country-centroid pin, so clicking it selects the whole country: highlight all of
          //               that country's visit cards, and scroll to the FIRST one in the list (the visits can be far apart in the scroll order).
          const chosen = this.filteredcoordinates.find(x => x.lat == lat && x.lng == lng);
          if (chosen != undefined) {
            this.selectedCountryId = chosen.countryId;
            this.selectedVisitId   = undefined;
            this.selectedUserId    = undefined;
            //RBW_20260723 - Also clear the individual-location coordinate, not just its id: getCardColour highlights a card via selectedUserCoordinate.id,
            //               so leaving it set keeps a previously selected child card green after selecting a whole country here (pin greys but card stayed green)
            this.selectedUserCoordinate = undefined;
            this.scrollToCard(this.filteredcoordinates.findIndex(x => (x.countryId ?? -2) == (chosen.countryId ?? -1)));
            this.addMarkers();
          }
          return;
        }

        var cord = this.filteredcoordinates.findIndex(x => x.lat == lat && x.lng == lng);
        if (cord < 0) {
          return;
        }
        if (this.selectedCountryId != undefined) {
          this.toggleMarkerColor(this.selectedCountryId ?? -1);
        }
        this.selectedCountryId = this.filteredcoordinates[cord].countryId;
        this.scrollToCard(cord);
        this.toggleMarkerColor(this.selectedCountryId ?? -1);
      } else {
        var allcord = this.locationCoordinates.find(x => x.lat == lat && x.lng == lng);
        if (this.selectedCountryId != undefined && this.selectedCountryId != allcord?.countryId) {
          this.selectedCountryId = allcord?.countryId;
        }
  
        var cord = this.filteredcoordinates.findIndex(x => x.lat == lat && x.lng == lng);
        if (this.selectedUserId != undefined) {
          this.toggleMarkerColor(this.selectedUserId ?? -1);
        }
        this.selectedCountryId = this.filteredcoordinates[cord].countryId;
        this.selectedCoordinate = this.filteredcoordinates[cord];
        this.selectedUserId = this.selectedCoordinate.id;
        this.selectedUserCoordinate= this.selectedCoordinate;
        this.toggleMarkerColor(this.selectedUserId ?? -1);
        setTimeout(() => {
            this.scrollToCard(cord);
          }
        , 500);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCountBubblesToggle(): void {
    try {
      this.setCountBubbles(!this.showCountBubbles);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setRiskDisplayMode(mode: 'auto' | 'live' | 'map' | 'risk'): void {
    try {
      if (this.riskDisplayMode===mode)
        return;

      this.riskDisplayMode=mode;

      if (mode==='risk' && this.bubblesAutoSwappedToPins) {
        this.showCountBubbles        =true;
        this.bubblesAutoSwappedToPins=false;
      }

      if (mode!=='map' && this.isMapReady() && !this.isZoomedOutForAggregates()) {
        this._suppressFitOnNextWorldZoom=true;
        this.worldZoomClick();
        return;
      }
      
      this.applyZoomPinSwap();
      this.refreshRiskStyling();
      this.addMarkers();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setCountBubbles(showBubbles: boolean): void {
    try {
      this.bubblesAutoSwappedToPins=false;

      if (this.showCountBubbles===showBubbles)
        return;

      this.showCountBubbles=showBubbles;

      this.addMarkers();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTileLayerChange(label: string): void {
    try {
      const option = this.tileLayerOptions.find(o => o.label === label);
      if (option && this.map) {
        this.activeTileLayer.removeFrom(this.map);
        option.layer.addTo(this.map);

        this.activeTileLayer       =option.layer;
        this.selectedTileLayerLabel=label;

        this.updateTileVisibilityForZoom();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showCoordinate(coordinate : { id: number | undefined, countryId: number | undefined, dateRange:string | undefined, lat: number | undefined, lng: number | undefined, label: string | undefined, startDate:OurDate | undefined, endDate:OurDate | undefined, username: string | undefined }) {
    const filterStartMidnight  = this.filterStartMs;
    const filterEndNextDay     = this.filterEndMs;
    const term = this.searchTerm.toLowerCase();
    var result = (this.locationCoordinates.length > 0) &&
                 (coordinate?.countryId ?? -1 > -1) &&
                 (coordinate.username ?? '').toLowerCase().includes(term) &&
                 (this.iccid == undefined ||
                  this.showCurrentLocation ||
                 (coordinate.startDate != undefined && 
                  this.filterDateEnd   != undefined && 
                  this.filterDateStart != undefined && 
                  ((coordinate.startDate.date.getTime() >= filterStartMidnight && coordinate.startDate.date.getTime() <= filterEndNextDay))));

    return result;
  }

  public scrollToCard(index: number) {
    try {
      //RBW_20260729 - Defer the lookup so it runs after change detection has rendered the card list.
      setTimeout(() => {
        if (!this.scrollContainer)
          return;

        const container = this.scrollContainer.nativeElement as HTMLElement;
        const card = container.querySelectorAll('.cardx')[index] as HTMLElement;

        if (card) {
          card.scrollIntoView({
            behavior: 'smooth', // smooth animation
            inline: 'center',   // for horizontal scroll
            block: 'nearest'    // for vertical scroll
          });
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    this.filterList();
  }

  private getEffectiveAccuracyLevel(): number {
    try {
      let level=this.locationAccuracyView;

      if (level<=0)
        level=(this.iccid != undefined && !this.locationSettingsOverride)
              ? this.inheritedAccuracyLevel
              : this.locationAccuracyLevel;

      return level;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.locationAccuracyView;
    }
  }

  private getSelectionZoomLevel(): number {
    try {
      if (this.selectedUserZoomLevel!==undefined && this.getEffectiveAccuracyLevel()===3)
        return this.selectedUserZoomLevel;

      return this.zoomedInLevel;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.zoomedInLevel;
    }
  }

  //#region Fit world

  private applyFitWorldView(force: boolean): void {
    try {
      if (!this.fitWorldToWidth || !this.isMapReady())
        return;

      const zoom: number | undefined=this.getFitWorldZoom();

      if (zoom===undefined)
        return;

      const wasFullyOut: boolean=this.map.getZoom()<=this.map.getMinZoom()+0.05;

      this.blankCoordinate.lat=MapSimLocationsComponent.fitWorldCentreLat;
      this.blankCoordinate.lng=MapSimLocationsComponent.fitWorldCentreLng;

      this.map.setMinZoom(zoom);

      if (force || wasFullyOut)
        this.map.setView([this.blankCoordinate.lat, this.blankCoordinate.lng], zoom, { animate: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getFitWorldZoom(): number | undefined {
    try {
      const size=this.map?.getSize();

      if (!size || size.x<=0 || size.y<=0)
        return undefined;

      const zoom: number=Math.log2(Math.max(size.x / MapSimLocationsComponent.fitWorldVisibleWidth, size.y) / 256);

      return Math.max(1, Math.floor(zoom * 10) / 10);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private onMapResizeForFitWorld=(): void => {
    try {
      this.applyFitWorldView(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  //#endregion

  private getInitialZoom(): number {
    try {
      if (this.fitWorldToWidth) {
        const fitZoom: number | undefined=this.getFitWorldZoom();

        if (fitZoom!==undefined)
          return fitZoom;
      }

      if (this.worldZoomLevel!==undefined)
        return this.worldZoomLevel;

      return window.innerWidth >= 1930 ? this.zoomedOutLevel + 1 : this.zoomedOutLevel;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.zoomedOutLevel;
    }
  }

  private toggleMarkerColor(id: number): void {
    var marker = this.findMarker(id);
    if (marker != undefined) {
      const currentIcon = marker.getIcon();
      if (currentIcon === iconGrey) {
        marker.setIcon(iconGreen);
      } else {
        marker.setIcon(iconGrey);
      }
    }
  }

  private fitBoundsToCountryMarkers(): boolean {
    try {
      if (!this.isMapReady())
        return false;

      const bounds = latLngBounds([]);
      this.countryLocationCoordinates.forEach(coord => {
        if (typeof coord.lat === 'number' && typeof coord.lng === 'number' &&
            (coord?.countryId ?? -1) > 0 && this.showCoordinate(coord)) {
          bounds.extend([coord.lat, coord.lng]);
        }
      });

      if (bounds.isValid()) {
        this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 5 });
        return true;
      }
      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private zoomToCountry(location: coordinateDTO): void {
    if ((location.id ?? -1) > -1) {
      if (location.islandMinLatitude != null && location.islandMaxLatitude != null &&
          location.islandMinLongitude != null && location.islandMaxLongitude != null) {
        if (this.countryLayer != undefined) {
          this.countryLayer.clearLayers();
        }
        const islandBounds = latLngBounds([[location.islandMinLatitude, location.islandMinLongitude],
                                           [location.islandMaxLatitude, location.islandMaxLongitude]]);
        this.map.fitBounds(islandBounds, { padding: [40, 40] });
        this.zoomedIn = LocationServicesZoomLevel.Country;
        this.addMarkers();
        return;
      }

      const filteredGeoJSON =
        (this.geoData as any).features.filter(
          (f: any) => f.properties.admin === location.country
        );
  
      if (filteredGeoJSON.length === 0) {
        if (this.countryLayer != undefined) {
          this.countryLayer.clearLayers();
        }

        var countryCoord = this.countryLocationCoordinates.find(x => x.id == location.countryId) ?? 
                          //  this.countryLocationCoordinates.find(x => x.id == location.id) ??
                           this.blankCoordinate;
        this.map.setView([countryCoord.lat ?? 0, countryCoord.lng ?? 0], 10); // Instant jump
        this.zoomedIn = LocationServicesZoomLevel.Country;
        this.addMarkers();

        return;
      }
  
      if (this.countryLayer != undefined) {
        this.countryLayer.clearLayers();
      }
  
      const countryLayer = geoJSON(filteredGeoJSON, {
        style: {
         color: '#ff7800',
         weight: 2,
         fillColor: '#fffcf0',
         fillOpacity: 0.5,
        },
      }).addTo(this.map);
      this.countryLayer = countryLayer;
  
      const countryBounds = countryLayer.getBounds();
      const latSpan       = countryBounds.getNorth() - countryBounds.getSouth();
      const lngSpan       = countryBounds.getEast()  - countryBounds.getWest();
      const markerBounds  = this.boundsForCountryMarkers(location.countryId);

      if ((latSpan > 20 || lngSpan > 40) && markerBounds.isValid()) {
        this.map.fitBounds(markerBounds, { padding: [40, 40], maxZoom: 8 });
      } else {
        this.map.fitBounds(countryBounds);
      }
      this.countryLayer.clearLayers();

      this.zoomedIn = LocationServicesZoomLevel.Country;
      this.addMarkers();
    }
  }

  private boundsForCountryMarkers(countryId: number | undefined) {
    const bounds = latLngBounds([]);
    this.locationCoordinates.forEach(c => {
      if (this.isVisitMode && c.visitId != this.selectedVisitId) {
        return;
      }
      if (c.countryId === countryId && typeof c.lat === 'number' && typeof c.lng === 'number') {
        bounds.extend([c.lat, c.lng]);
      }
    });
    return bounds;
  }

  private fitToCountryBounds(coord: coordinateDTO): boolean {
    try {
      if (!this.isMapReady())
        return false;

      if (coord.islandMinLatitude != null && coord.islandMaxLatitude != null &&
          coord.islandMinLongitude != null && coord.islandMaxLongitude != null) {
        this.map.fitBounds(latLngBounds([[coord.islandMinLatitude, coord.islandMinLongitude],
                                         [coord.islandMaxLatitude, coord.islandMaxLongitude]]), { padding: [40, 40] });
        return true;
      }

      const features = this.geoData
                       ? (this.geoData as any).features.filter((f: any) => f.properties.admin === coord.country)
                       : [];

      if (features.length > 0) {
        const countryBounds = geoJSON(features).getBounds();
        if (countryBounds.isValid()) {
          this.map.fitBounds(countryBounds, { padding: [40, 40] });
          return true;
        }
      }

      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion

  //#region Map buttons

  public isCountryAccuracyView(): boolean {
    try {
      return this.getEffectiveAccuracyLevel()===1; //1=Country
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public onCardClick(coordinate : coordinateDTO, event?: Event): void {
    try {
      if ((coordinate.countryId ?? -1) < -100000) {
        this.notifyHomeGuard(event);
        return;
      }

      this._userSelectedDuringLoad = this.pendingLocationRequests > 0;

      this.hideLocalToast();

      //RBW_20260716 - Disabled / Unknown / Failed cards (negative countryId, not Home Guard) have no real location. They still expand to list their
      //               SIMs, but the map just goes to the world view rather than zooming to a placeholder location.
      const isSentinel = (coordinate.countryId ?? 0) < 0;

      if (this.isExpandableGroup(coordinate)) {
        const key         = this.groupKey(coordinate);
        const wasExpanded = this.expandedGroupKey === key;
        this.expandedGroupKey = wasExpanded ? undefined : key;   // accordion toggle

        this.selectedUserId         = undefined;
        this.selectedUserCoordinate = undefined;

        //RBW_20260716 - Expanding replaces the country pin with the individual location pins, so the country-level highlight no longer applies -
        //               clear it so neither the group card nor its children stay green.
        if (this.isCountryAccuracyView() && !isSentinel) {
          this.selectedCountryId = wasExpanded ? undefined : (coordinate.countryId ?? undefined);
        }
        else {
          this.selectedCountryId = undefined;
          this.selectedVisitId   = undefined;
        }

        this.addMarkers();   // swap in the expanded group's individual pins (or revert to the country pin on collapse)

        if (this.zoomInOnSelection) {
          if (isSentinel)
            this.worldZoomClick();              // no real location - just show the world view
          else if (wasExpanded)
            this.fitBoundsToCountryMarkers();   // collapsed: back to the countries overview
          else
            this.zoomToExpandedGroup();         // expanded: zoom into the country's individual pins (stays in the grouped/World view)
        }

        return;
      }

      //RBW_20260716 - A single sentinel location (not a multi-SIM group) also has no real location, so just go to the world view.
      if (isSentinel) {
        this.selectedCountryId      = undefined;
        this.selectedVisitId        = undefined;
        this.selectedUserId         = undefined;
        this.selectedUserCoordinate = undefined;
        this.worldZoomClick();
        return;
      }

      this.selectLocationCard(coordinate);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private groupKey(coord: coordinateDTO): number {
    return this.isVisitMode ? (coord.visitId ?? -1) : (coord.countryId ?? -1);
  }

  public isExpandableGroup(coord: coordinateDTO): boolean {
    return this.zoomedIn == LocationServicesZoomLevel.World && !this.showAllLocationCards && (coord.countryId ?? -100000) > -100000 && this.getCountrySimCount(coord) > 1;
  }

  public isGroupExpanded(coord: coordinateDTO): boolean {
    return this.expandedGroupKey != undefined && this.groupKey(coord) === this.expandedGroupKey;
  }

  private matchesSearch(coord: coordinateDTO): boolean {
    const term = this.searchTerm.toLowerCase();
    return term === '' || (coord.username ?? '').toLowerCase().includes(term);
  }

  public groupChildren(coord: coordinateDTO): coordinateDTO[] {
    const children = (this.isVisitMode
                     ? this.locationCoordinates.filter(c => (c.visitId  ?? -1) === (coord.visitId  ?? -1))
                     : this.locationCoordinates.filter(c => (c.countryId ?? -1) === (coord.countryId ?? -1)))
                     .filter(c => this.matchesSearch(c));
    return [...children].sort((a, b) => (b.endDate?.date.getTime() ?? 0) - (a.endDate?.date.getTime() ?? 0));
  }

  public groupHasCountryOnly(coord: coordinateDTO): boolean {
    try {
      if (this.isVisitMode || (coord?.countryId ?? -1)<=0)
        return false;

      return this.locationCoordinates.some(c => (c.countryId ?? -1)===coord.countryId && c.countryOnly===true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private childrenForExpandedGroup(): coordinateDTO[] {
    if (this.expandedGroupKey == undefined)
      return [];

    return (this.isVisitMode
           ? this.locationCoordinates.filter(c => (c.visitId  ?? -1) === this.expandedGroupKey)
           : this.locationCoordinates.filter(c => (c.countryId ?? -1) === this.expandedGroupKey))
           .filter(c => this.matchesSearch(c))
           .map(c => this.withCountryFallbackFix(c));
  }

  private withCountryFallbackFix(coord: coordinateDTO): coordinateDTO {
    try {
      if (this.hasUsableFix(coord))
        return coord;

      const countryCoord = this.countryLocationCoordinates.find(c => (c.countryId ?? -1) === (coord.countryId ?? -2));

      if (countryCoord == undefined || !this.hasUsableFix(countryCoord))
        return coord;

      return { ...coord, lat: countryCoord.lat, lng: countryCoord.lng, isCentroidFallback: true };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return coord;
    }
  }

  private zoomToExpandedGroup(): void {
    try {
      if (!this.isMapReady())
        return;

      const children = this.childrenForExpandedGroup();

      //RBW_20260723 - At Country accuracy every child location shares the one country centroid, so frame the whole country polygon instead of the single point
      if (this.isCountryAccuracyView() && children.length > 0 && this.fitToCountryBounds(children[0]))
        return;

      const bounds = latLngBounds([]);
      children.forEach(c => {
        if ((c.countryId ?? -1) > 0 && this.hasUsableFix(c))
          bounds.extend([c.lat!, c.lng!]);
      });

      //RBW_20260716 - Fit all the group's pins; cap the zoom at a country-level 8 so a tightly-clustered group (or one masked to a single point) doesn't zoom in too far
      if (bounds.isValid())
        this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 8 });
      else if (children.length>0)
        this.fitToCountryBounds(children[0]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private hasUsableFix(coord: coordinateDTO): boolean {
    try {
      return typeof coord?.lat==='number' && typeof coord?.lng==='number'
             && isFinite(coord.lat) && isFinite(coord.lng)
             && !(coord.lat===0 && coord.lng===0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //RBW_20260716 - Select an individual location card and centre/zoom the map on it (respecting the auto-zoom switch). Exception: a child card at Country
  //               accuracy keeps the current zoom.
  public selectLocationCard(coord: coordinateDTO, fromChild: boolean = false): void {
    try {
      coord = this.withCountryFallbackFix(coord);
      
      if (this.pendingLocationRequests > 0)
        this._userSelectedDuringLoad = true;

      this.selectedUserId         = coord.id;
      this.selectedUserCoordinate = coord;

      if (!this.isCountryAccuracyView() && this.zoomedIn == LocationServicesZoomLevel.World) {
        this.selectedCountryId = undefined;
        this.selectedVisitId   = undefined;
      }

      //RBW_20260716 - Don't move the map for a sentinel location (Disabled/Unknown/Failed, negative countryId) - there's no real place to zoom to
      if (this.isMapReady() && (coord.countryId ?? 0) >= 0) {
        const countryAccuracy = this.isCountryAccuracyView();
        const canPointAtIt    = this.hasUsableFix(coord);
        const isApproximate   = coord.isCentroidFallback === true;

        if (!this.zoomInOnSelection) {
          //RBW_20260723 - Auto-zoom off: keep the current zoom level but still recentre the map on the selected pin so it reorientates to the clicked card.
          if (canPointAtIt)
            this.map.setView([coord.lat ?? 0, coord.lng ?? 0], this.map.getZoom());
        }
        //RBW_20260723 - Auto-zoom on. A child card at Country accuracy keeps the group's existing expand view. Any other card at Country accuracy fits the WHOLE country polygon. Town/City and Cell Tower accuracy zoom right in to the location.
        else if (!(fromChild && countryAccuracy)) {
          if (countryAccuracy || isApproximate) {
            if (!this.fitToCountryBounds(coord) && canPointAtIt && !isApproximate)
              this.map.setView([coord.lat ?? 0, coord.lng ?? 0], this.zoomedCountryLevel);
          }
          else if (canPointAtIt) {
            this.map.setView([coord.lat ?? 0, coord.lng ?? 0], this.getSelectionZoomLevel());
          }
        }
      }

      this.addMarkers();
      this.scrollToLocation(coord);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private scrollToLocation(coord: coordinateDTO): void {
    try {
      //RBW_20260729 - Check/read the scroll container inside the deferred callback, not before it: when this scroll follows expanding the Locations section from an
      //               open settings panel, the container is only created on the next change-detection pass, so reading it up front would bail early.
      setTimeout(() => {
        if (!this.scrollContainer)
          return;

        const container = this.scrollContainer.nativeElement as HTMLElement;
        const el = container.querySelector(`[data-loc-id="${coord.id}"]`) as HTMLElement | null;
        if (el)
          el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private hideLocalToast(): void {
    this.localToastVisible = false;
    clearTimeout(this.localToastTimer);
  }

  private notifyHomeGuard(event?: Event): void {
    this.localToastMessage = "Home Guard active. No location data stored for home country";
    this.positionLocalToast(event);
    this.localToastVisible = true;
    clearTimeout(this.localToastTimer);
    this.localToastTimer = setTimeout(() => { this.localToastVisible = false; }, ToastShowDelay.Success);
  }

  private positionLocalToast(event?: Event): void {
    const cardEl = event?.currentTarget as HTMLElement | null;
    const hostEl = this.el?.nativeElement as HTMLElement | undefined;
    if (cardEl == null || hostEl == undefined) {
      this.localToastTop   = 16;
      this.localToastRight = 16;
      return;
    }
    const hostRect = hostEl.getBoundingClientRect();
    const cardRect = cardEl.getBoundingClientRect();
    this.localToastTop   = Math.max(0, cardRect.top - hostRect.top);
    this.localToastRight = Math.max(0, hostRect.right - cardRect.left + 8);
  }

  public countrySelectClick() {
    this.showCountries = !this.showCountries;

    if (!this.showCountries) {
      this.geoJsonLayer.clearLayers();
    } else {
      this.colourMap(this.map);
    }
  }

  public countryZoomClick() {
    if (this.countryStats.find(x => x.countryId > 1) == undefined) {
      this.zoomedIn          = LocationServicesZoomLevel.World;
      this.selectedCountryId = undefined;
      this.selectedUserId    = undefined;
      return;
    }

    if (this.isVisitMode) {
      if (this.selectedUserCoordinate != undefined && (this.selectedUserCoordinate.countryId ?? -1) > -1) {
        this.selectedVisitId   = this.selectedUserCoordinate.visitId;
        this.selectedCountryId = this.selectedUserCoordinate.countryId;
      } else if (this.selectedVisitId == undefined) {
        const latest = [...this.countryStats].sort((a, b) => (b.maxDate?.date.getTime() ?? 0) - (a.maxDate?.date.getTime() ?? 0))[0];
        this.selectedVisitId   = latest?.visitId;
        this.selectedCountryId = latest?.countryId;
      }
    }

    this.zoomedIn = LocationServicesZoomLevel.Country;
    if (this.selectedCountryId == undefined && this.countryLocationCoordinates.length > 0) {
      this.selectedCountryId = this.countryLocationCoordinates.find(x => (x.countryId ?? 0) > 0)?.countryId ?? 0;
    } 

    if (this.selectedUserId == undefined || this.selectedUserId < 0) {
      var coordid = this.countryLocationCoordinates.find(x => (x.countryId ?? 0) == this.selectedCountryId)?.id ?? 0;
      this.locationSelected(coordid ?? -1, true);
    } else {
      this.locationSelected(this.selectedUserId ?? -1, true);
    }

    if (this.selectedUserId != undefined) {
      setTimeout(() => {
          var index = this.filteredcoordinates.findIndex(x => x.id == this.selectedUserId);
          this.scrollToCard(index);
        }
      , 500);
    }
  }

  public travelBriefingClick(event: Event, coordinate: coordinateDTO): void {
    try {
      event.stopPropagation();
      event.preventDefault();

      this.travelBriefingRequested.emit({
        countryName: coordinate?.country  ?? '',
        iccid      : coordinate?.iccid    ?? '',
        username   : coordinate?.username ?? ''
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public iccidClick(event: Event, iccid: string): void {
    try {
      if (this._isIccidClickLoading) return;
      this._isIccidClickLoading=true;

      this.globalEventService.broadcastIccidClicked(
        iccid,
        ()  => { this._isIccidClickLoading=false; },
        ()  => { this._isIccidClickLoading=false; },
        true
      );
      event.stopPropagation();
    }
    catch(e) {
      this._isIccidClickLoading=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public findCentre(): void {
    try {
      const centre = this.map.getCenter();
      console.log(`Map centre — Lat: ${centre.lat}, Lng: ${centre.lng}, windowsize: ${window.innerWidth}`);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public worldZoomClick() {
    this.zoomedIn = LocationServicesZoomLevel.World;
    if ((this.selectedCountryId ?? 0) < 0) {
      this.selectedCountryId = undefined;
    }
    if (this.isVisitMode) {
      this.selectedVisitId = undefined;
    }

    const skipFit: boolean=this._suppressFitOnNextWorldZoom;
    this._suppressFitOnNextWorldZoom=false;

    if (skipFit && this.isMapReady()) {
      this.selectedCoordinate = undefined;
      this.map.setView([this.blankCoordinate.lat ?? 0, this.blankCoordinate.lng ?? 0], this.getInitialZoom());
      this.addMarkers();
    }
    else if (this.currentLocationData == null && this.fitBoundsToCountryMarkers()) {
      this.selectedCoordinate = undefined;
      this.addMarkers();
    } else {
      this.locationSelected(-1, true);
    }

    if (this.selectedCountryId != undefined) {
      var index = this.filteredcoordinates.findIndex(x => x.id == this.selectedCountryId);
      this.scrollToCard(index);
    }
  }

  public resetMapView(): void {
    try {
      if (!this.isMapReady())
        return;

      this.selectedCountryId           =undefined;
      this.selectedUserId              =undefined;
      this.selectedUserCoordinate      =undefined;
      this._suppressFitOnNextWorldZoom=true;
      
      this.worldZoomClick();
      
      if (this.applyZoomPinSwap())
        this.addMarkers();

      this.setBubbleSizeForZoom();
      this.refreshRiskStyling();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public zoomInClick() {
    this.zoomInOnSelection = !this.zoomInOnSelection;
  }

  public setWorldCardMode(mode: 'countries' | 'allLocations') {
    this.worldCardMode          = mode;
    this.selectedCountryId      = undefined;
    this.selectedVisitId        = undefined;
    this.selectedUserId         = undefined;
    this.selectedUserCoordinate = undefined;
    this.expandedGroupKey       = undefined;   //RBW_20260716 - collapse any open group when switching grouping mode
    this.worldZoomClick();
  }

  //#endregion

  //#region Modals

  public completedModalHasBeenClosed() {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
 
  public confirmSetCompanyLocationServices() {
    try {
      this.locationServicesToggleAction= "enable";

      this.toggleConfirmationModal.openForm("WARNING",
                                            `Are you sure you want to ${this.locationServicesToggleAction} location services for these users?`,
                                            undefined,
                                            OurColors.Red,
                                            OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private EnableProcessComplete() {
    try {
      var message   = `Location Services have been enabled`;

      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setCompanyLocationServices(event : Event) {
    try {
      event.stopPropagation();
      this.confirmSetCompanyLocationServices();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Location Settings

  public invalidateMapSize(): void {
    try {
      if (this.isMapReady())
        this.map.invalidateSize();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleSidebarCollapsed(): void {
    try {
      this.sidebarCollapsed=!this.sidebarCollapsed;
      this.sidebarCollapsedChange.emit(this.sidebarCollapsed);

      setTimeout(() => {
        try {
          this.map?.invalidateSize();
        }
        catch(e) {
          this.exceptionsService.handleException(<Error>e);
        }
      }, MapSimLocationsComponent.sidebarSlideMs + 20);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleLocationsPanel(): void {
    try {
      this.locationSettingsExpanded = false;
      this.mapSettingsExpanded      = false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private ensureLocationsSectionOpen(): void {
    try {
      if (this.settingsPanelExpanded) {
        this.locationSettingsExpanded = false;
        this.mapSettingsExpanded      = false;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onUserSearchInput(): void {
    try {
      this.ensureLocationsSectionOpen();
      this.filterList();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleLocationSettingsPanel(): void {
    try {
      this.locationSettingsExpanded=!this.locationSettingsExpanded;

      if (this.locationSettingsExpanded)
        this.mapSettingsExpanded=false;

      if (this.locationSettingsExpanded && !this.locationSettingsLoaded)
        this.loadLocationSettings();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleMapSettingsPanel(): void {
    try {
      this.mapSettingsExpanded=!this.mapSettingsExpanded;

      if (this.mapSettingsExpanded)
        this.locationSettingsExpanded=false;

      if (this.mapSettingsExpanded && !this.locationSettingsLoaded)
        this.loadLocationSettings();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onGroupingToggle(): void {
    try {
      const mode = this.worldCardMode === 'countries' ? 'allLocations' : 'countries';

      if (this.showCurrentLocation) {
        this.worldCardMode = mode;
        return;
      }

      this.setWorldCardMode(mode);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private tryLoadLocationSettings(): void {
    try {
      if (this.locationSettingsLoaded)
        return;

      const simInputsReady     = this.iccid != undefined && this.locationOwnerUserId != undefined;
      const companyInputsReady = this.companyId != undefined;

      if (!simInputsReady && !companyInputsReady)
        return;

      this.loadLocationSettings();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateLastLocationOnlyResolved(): void {
    try {
      this.lastLocationOnlyResolved = this.lastLocationOnlyUserResolved && this.lastLocationOnlyCompanyResolved;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadLocationSettings(): void {
    try {
      this.locationSettingsLoaded=true;

      if (this.companyId != undefined) {
        this.companiesService.getById(this.companyId).subscribe({
          next : company => {
            this.locationCompany               =company;
            this.locationAccuracyLevel         =company.locationAccuracyLevelDefault   ?? 3;
            this.locationEnableForNewByDefault =company.locationEnableForNewByDefault  ?? false;
            this.locationLastLocationOnly      =company.locationLastLocationOnly       ?? false;
            //RBW_20260922 - System default is that user opt in IS required, so an absent flag means true, not false.
            this.locationRequireUserOptIn      =company.locationRequireUserOptIn       ?? true;
            this.locationCountryAlwaysVisible  =company.locationCountryAlwaysVisible   ?? false;
            this.travelRiskExtendedOfflineHours=company.travelRiskExtendedOfflineHours ?? null;
            this.resolveInheritedHomeCountry(company.countryID);
          },
          error: error => { this.exceptionsService.handleException(new Error(error)); }
        });

        this.componentAccessUserService.getCompanyHomeGuardState(this.companyId).subscribe({
          next : result => {
            this.locationOutsideHomeCountryOnly=result?.result ?? false;
            //RBW_20260713 - Baseline so the dialog Submit only writes the grant when it actually changed
            this.locationHomeGuardOriginal     =this.locationOutsideHomeCountryOnly;
          },
          error: error  => { this.exceptionsService.handleException(new Error(error)); }
        });
      }
      else if (this.iccid != undefined) {
        this.lastLocationOnlyUserResolved    = this.locationOwnerUserId == undefined;
        this.lastLocationOnlyCompanyResolved = this.locationCompanyId == undefined;
        this.updateLastLocationOnlyResolved();

        if (this.locationOwnerUserId != undefined) {
          this.componentAccessUserService.getUserHomeGuardState(this.locationOwnerUserId).subscribe({
            next : result => {
              this.locationOutsideHomeCountryOnly=result?.result ?? false;
              //RBW_20260713 - Baseline so the Manage SIM Submit only writes the user grant when it actually changed
              this.locationHomeGuardOriginal     =this.locationOutsideHomeCountryOnly;
            },
            error: error  => { this.exceptionsService.handleException(new Error(error)); }
          });

          this.locationAwarenessService.getStatus(this.locationOwnerUserId).subscribe({
            next : awareness => {
              this.locationSettingsOverride =awareness?.locationSettingsOverride ?? false;
              this.locationAccuracyLevel    =awareness?.locationAccuracyLevel ?? 3;
              this.locationLastLocationOnly =awareness?.locationLastLocationOnly ?? false;
              this.applyAwarenessStatus(awareness);
              //RBW_20260723 - baseline the loaded values so Submit only re-saves the settings if the user actually changes them (a tracking-only change must not fire updateLocationSettings)
              this.locationSettingsOverrideOriginal=this.locationSettingsOverride;
              this.locationAccuracyLevelOriginal   =this.locationAccuracyLevel;
              this.locationLastLocationOnlyOriginal=this.locationLastLocationOnly;
              this.lastLocationOnlyUserResolved=true;
              this.updateLastLocationOnlyResolved();
            },
            error: error => { this.exceptionsService.handleException(new Error(error)); }
          });

          this.usersService.getById(this.locationOwnerUserId).subscribe({
            next : user => { this.resolveUserHomeCountry(user?.countryID); },
            error: error => { this.exceptionsService.handleException(new Error(error)); }
          });
        }

        //RBW_20260713 - Retrieve the owning company's defaults so they can be shown (read-only) while this SIM is inheriting
        if (this.locationCompanyId != undefined) {
          this.companiesService.getById(this.locationCompanyId).subscribe({
            next : company => {
              this.inheritedAccuracyLevel   =company.locationAccuracyLevelDefault ?? 3;
              this.inheritedLastLocationOnly=company.locationLastLocationOnly ?? false;
              this.resolveInheritedHomeCountry(company.countryID);
              this.lastLocationOnlyCompanyResolved=true;
              this.updateLastLocationOnlyResolved();
            },
            error: error => { this.exceptionsService.handleException(new Error(error)); }
          });

          this.componentAccessUserService.getCompanyHomeGuardState(this.locationCompanyId).subscribe({
            next : result => { this.inheritedHomeGuard=result?.result ?? false; },
            error: error  => { this.exceptionsService.handleException(new Error(error)); }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260713 - Resolve the company's home-country id to a display name (alias preferred), loading the country list if needed
  private resolveInheritedHomeCountry(countryId: number | null | undefined): void {
    try {
      if (countryId == undefined) {
        this.inheritedHomeCountry='';
        return;
      }

      const setName=(list: CountryDTO[]) => {
        const country=list.find(c => c.id == countryId);
        this.inheritedHomeCountry=country?.alias ?? country?.countryName ?? '';
      };

      if (this.countriesService.allCountries != undefined) {
        setName(this.countriesService.allCountries);
      } else {
        this.countriesService.get().subscribe({
          next : list  => { this.countriesService.allCountries=list; setName(list); },
          error: error => { this.exceptionsService.handleException(new Error(error)); }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260723 - Resolve the SIM owner's own home country name. A user with no country set (id null/0) has no personal home country and uses the company's,
  //               so userHomeCountry is left blank in that case (and the UI keeps showing the company value).
  private resolveUserHomeCountry(countryId: number | null | undefined): void {
    try {
      if (countryId == undefined || countryId <= 0) {
        this.userHomeCountry='';
        return;
      }

      const setName=(list: CountryDTO[]) => {
        const country=list.find(c => c.id == countryId);
        this.userHomeCountry=country?.alias ?? country?.countryName ?? '';
      };

      if (this.countriesService.allCountries != undefined) {
        setName(this.countriesService.allCountries);
      } else {
        this.countriesService.get().subscribe({
          next : list  => { this.countriesService.allCountries=list; setName(list); },
          error: error => { this.exceptionsService.handleException(new Error(error)); }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public goToCompanySettings(): void {
    try {
      if (this.companyId != undefined)
        this.globalEventService.broadcastCompanyClicked(this.companyId, () => this.reloadAfterCompanySave(), undefined, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private reloadAfterCompanySave(): void {
    try {
      this.loadLocationSettings();
      this.refresh();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260713 - Map an accuracy tier id to its display label (NULL/unset falls back to Cell Tower, matching the backend default)
  public accuracyLabel(level: number | undefined): string {
    try {
      switch (level) {
        case 1 : return 'Country';
        case 2 : return 'Town / City';
        default: return 'Cell Tower';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  public locationStatusLabel(coordinate: coordinateDTO): string {
    try {
      if (coordinate?.countryOnly===true)
        return 'Country only';

      if (coordinate?.positionApproximate===true)
        return 'Approximate';

      switch (coordinate?.countryId) {
        case -1 : return 'Disabled';
        case -2 : return 'Unknown';
        case -3 : return 'Failed';
        case -4 : return 'Awaiting';
        default : return 'Active';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  public locationAwarenessStatusClass(): string {
    try {
      switch (this.locationAwarenessStatusId) {
        case LocationAwarenessStatus.AwaitingConfirmation: return 'location-pill location-pill-unknown';
        case LocationAwarenessStatus.On                  : return 'location-pill location-pill-active';
        default                                          : return 'location-pill location-pill-disabled';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'location-pill';
    }
  }

  public locationStatusClass(coordinate: coordinateDTO): string {
    try {
      if (coordinate?.countryOnly===true)
        return 'location-pill location-pill-disabled';

      if (coordinate?.positionApproximate===true)
        return 'location-pill location-pill-unknown';

      switch (coordinate?.countryId) {
        case -1 : return 'location-pill location-pill-disabled';
        case -2 : return 'location-pill location-pill-unknown';
        case -3 : return 'location-pill location-pill-failed';
        case -4 : return 'location-pill location-pill-unknown';
        default : return 'location-pill location-pill-active';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'location-pill';
    }
  }

  public onLocationAccuracyChange(level: number): void {
    try {
      this.locationAccuracyLevel=level;

      //RBW_20260713 - Held in-memory and persisted on the dialog Submit (company + SIM are both transactional)
      if (this.iccid != undefined && this.locationSettingsOverride)
        this.locationSettingsDirty=true;

      //RBW_20260713 - Preview the selected level on the map straight away: the backend re-masks the whole view to it, so the pins refresh
      this.locationAccuracyView=level;
      this.refresh();

      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationEnableForNewChange(enabled: boolean): void {
    try {
      //RBW_20260713 - Held in-memory; persisted with the company on the dialog Submit
      this.locationEnableForNewByDefault=enabled;
      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onEditLocationConsentTemplate(): void {
    try {
      this.editLocationConsentTemplate.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationRequireUserOptInChange(enabled: boolean): void {
    try {
      this.locationRequireUserOptIn=enabled;
      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationCountryAlwaysVisibleChange(enabled: boolean): void {
    try {
      this.locationCountryAlwaysVisible=enabled;
      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTravelRiskExtendedOfflineHoursChange(value: string): void {
    try {
      const hours: number=Math.floor(Number(value));

      this.travelRiskExtendedOfflineHours=(value ?? '').toString().trim()=='' || isNaN(hours) || hours<1 ? null : hours;
      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationLastLocationOnlyChange(enabled: boolean): void {
    try {
      this.locationLastLocationOnly=enabled;

      if (this.iccid != undefined && this.locationSettingsOverride)
        this.locationSettingsDirty=true;

      this.enforceLastLocationOnlyRange();

      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyAwarenessStatus(awareness: UserLocationAwarenessDTO | undefined): void {
    try {
      this.locationAwarenessStatusId          = awareness?.statusID ?? LocationAwarenessStatus.Off;
      this.locationAwarenessStatusDescription = awareness?.statusDescription ?? 'Off';

      this.locationTrackingRequested         = this.locationAwarenessStatusId !== LocationAwarenessStatus.Off;
      this.locationTrackingRequestedOriginal = this.locationTrackingRequested;
      this.locationTrackingDirty             = false;

      const effective = this.locationAwarenessStatusId === LocationAwarenessStatus.On;

      if (this.locationServices !== effective) {
        this.locationServices         = effective;
        this.locationServicesOriginal = effective;

        if (!effective) {
          this.locationCoordinates        = [];
          this.countryLocationCoordinates = [];
          this.markersLayer?.clearLayers();
          this.loading                    = false;
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enforceLastLocationOnlyRange(): void {
    try {
      if (this.lastLocationOnlyActive && this.historyDateRange !== 'last')
        this.onHistoryRangeChange('last');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationTrackingChange(enabled: boolean): void {
    try {
      this.locationTrackingRequested = enabled;
      this.locationServices          = enabled;
      this.locationSettingsDirty     = true;
      this.locationTrackingDirty     = true;

      this.locationTrackingView = enabled === this.locationTrackingRequestedOriginal ? -1 : (enabled ? 1 : 0);

      if (!enabled) {
        this.locationCoordinates        = [];
        this.countryLocationCoordinates = [];
        this.markersLayer?.clearLayers();
        this.loading                    = false;
      } else if (this.showCurrentLocation) {
        this.getCurrentLocation();
      } else {
        this.getSIMLocations();
      }

      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationHomeGuardChange(enabled: boolean): void {
    try {
      //RBW_20260713 - Transactional for both company and SIM: held in-memory and committed on the dialog Submit
      this.locationOutsideHomeCountryOnly=enabled;
      this.locationSettingsDirty         =true;

      this.locationHomeGuardView = enabled === this.locationHomeGuardOriginal ? -1 : (enabled ? 1 : 0);
      this.refresh();

      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationOverrideChange(override: boolean): void {
    try {
      this.locationSettingsOverride=override;
      this.locationSettingsDirty   =true;

      this.locationAccuracyView=override ? this.locationAccuracyLevel : 0;

      this.locationHomeGuardView = override
                                   ? (this.locationOutsideHomeCountryOnly === this.locationHomeGuardOriginal ? -1 : (this.locationOutsideHomeCountryOnly ? 1 : 0))
                                   : (this.inheritedHomeGuard ? 1 : 0);
      this.enforceLastLocationOnlyRange();
      this.refresh();

      this.locationSettingsChanged.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public commitCompanyLocationSettings(): void {
    try {
      if (this.companyId == undefined || !this.locationSettingsLoaded)
        return;

      if (this.locationOutsideHomeCountryOnly === this.locationHomeGuardOriginal)
        return;

      this.componentAccessUserService.setCompanyHomeGuard(this.companyId, this.locationOutsideHomeCountryOnly).subscribe({
        next : () => { this.locationHomeGuardOriginal=this.locationOutsideHomeCountryOnly; },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public commitSimLocationSettings(): void {
    try {
      if (this.iccid == undefined || !this.locationSettingsLoaded || !this.locationSettingsDirty)
        return;

      //RBW_20260723 - Collect only the saves that are actually needed, run them together, and refresh the other screens ONCE when they all complete
      //               (rather than one refresh per save). Each save re-baselines its own state in a tap so a later Submit won't re-fire it.
      const saves: Observable<any>[] = [];

      //RBW_20260723 - All Location Awareness settings are now held on the owning USER (tracking mirrored to the user's SIMs on the backend), so everything
      //               here is keyed by locationOwnerUserId. Nothing to persist without it.
      if (this.locationOwnerUserId != undefined) {
        //RBW_20260723 - Accuracy override/level: only when changed.
        if (this.locationSettingsOverride  !== this.locationSettingsOverrideOriginal ||
            this.locationAccuracyLevel     !== this.locationAccuracyLevelOriginal    ||
            this.locationLastLocationOnly  !== this.locationLastLocationOnlyOriginal) {
          this.locationSettingsSaving = true;
          saves.push(this.devicesService.updateLocationSettings(this.locationOwnerUserId,
                                                                this.locationSettingsOverride,
                                                                this.locationAccuracyLevel,
                                                                this.locationLastLocationOnly,
                                                                this.locationChangeReason).pipe(
            tap(() => {
              this.locationSettingsSaving            = false;
              this.locationSettingsOverrideOriginal  = this.locationSettingsOverride;
              this.locationAccuracyLevelOriginal     = this.locationAccuracyLevel;
              this.locationLastLocationOnlyOriginal  = this.locationLastLocationOnly;
            })
          ));
        }

        //RBW_20260715 - Location Tracking: the endpoint toggles the stored user state, so one call flips the saved (baseline) value to the current in-memory value.
        if (this.locationTrackingDirty && this.locationTrackingRequested !== this.locationTrackingRequestedOriginal) {
          saves.push(this.devicesService.toggleLocationServices(this.locationOwnerUserId).pipe(
            tap(() => {
              this.locationTrackingRequestedOriginal = this.locationTrackingRequested;
              this.locationTrackingDirty             = false;
            })
          ));
        }

        //RBW_20260723 - Home Guard (owning-user grant). Inherit mode drops any explicit per-user override so the company setting applies (a stale explicit
        //               "off" would otherwise keep suppressing the company "on"); Override mode stores the explicit value when it changed.
        if (!this.locationSettingsOverride) {
          saves.push(this.componentAccessUserService.clearUserHomeGuard(this.locationOwnerUserId).pipe(
            tap(() => { this.locationHomeGuardOriginal = this.inheritedHomeGuard; })
          ));
        }
        else if (this.locationOutsideHomeCountryOnly !== this.locationHomeGuardOriginal) {
          saves.push(this.componentAccessUserService.setUserHomeGuard(this.locationOwnerUserId, this.locationOutsideHomeCountryOnly).pipe(
            tap(() => { this.locationHomeGuardOriginal = this.locationOutsideHomeCountryOnly; })
          ));
        }
      }

      this.locationSettingsDirty = false;

      if (saves.length === 0)
        return;

      //RBW_20260723 - Once every save has completed, tell the other screens to re-fetch exactly once.
      forkJoin(saves).subscribe({
        next : () => {
          this.notifyLocationSettingsSaved();
          this.afterVisibilitySave();
        },
        error: error => { this.locationSettingsSaving = false; this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public afterVisibilitySave(): void {
    try {
      this.locationChangeReason='';

      if (this.visibilityChangesExpanded)
        this.loadVisibilityChanges();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getVisibilityChangeBy(change: LocationVisibilityChangeDTO): string {
    try {
      return (change?.changedByName ?? '').trim()
             || (change?.changedByPartnerCompanyName ?? '').trim()
             || (change?.sourceName ?? '');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  public getVisibilitySettingLabel(change: LocationVisibilityChangeDTO): string {
    try {
      switch (change?.settingKey) {
        case 'AccuracyLevel'       :
        case 'AccuracyLevelDefault':
          return 'Accuracy level';
        case 'AgreedAccuracyLevel':
          return 'Partner agreed accuracy';
        case 'Consent':
          return 'Consent';
        case 'CountryAlwaysVisible':
          return 'Country always visible';
        case 'EnableForNewByDefault':
          return 'Enable for new users by default';
        case 'ExtendedOfflineHours':
          return 'Extended Offline alert after (hours)';
        case 'HomeGuard':
          return 'Home guard';
        case 'LastLocationOnly':
          return 'Last location only';
        case 'LocationServices':
          return 'Location tracking';
        case 'PartnerLink':
          return 'Partner link';
        case 'RequireUserOptIn':
          return 'User opt-in required';
        case 'SettingsOverride':
          return 'Settings mode override';
        default:
          return change?.settingKeyName || change?.settingKey || '';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return change?.settingKey ?? '';
    }
  }

  public getVisibilityValueLabel(change: LocationVisibilityChangeDTO,
                                 value : string | null | undefined): string {
    try {
      const text: string=(value ?? '').trim();

      if (text=='')
        return 'none';

      if (text.toLowerCase()=='true')
        return 'On';

      if (text.toLowerCase()=='false')
        return 'Off';

      if (change?.settingKey=='AccuracyLevel' || change?.settingKey=='AccuracyLevelDefault' || change?.settingKey=='AgreedAccuracyLevel')
        return this.accuracyLabel(Number(text));

      return text;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return value ?? '';
    }
  }

  public getVisibilityChangeScopeLabel(change: LocationVisibilityChangeDTO): string {
    try {
      const subject: string=(change?.subjectName ?? '').trim();

      switch (change?.scope) {
        case eVisibilityChangeScope.Company:
          return 'Company';
        case eVisibilityChangeScope.User:
          return subject!='' ? 'User: ' + subject : 'User';
        case eVisibilityChangeScope.Sim:
          return subject!='' ? 'SIM: ' + subject : 'SIM';
        case eVisibilityChangeScope.PartnerLink:
          return 'Partner link';
        default:
          return '';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private loadVisibilityChanges(): void {
    try {
      const fromUtc: Date=new Date(Date.now() - 90 * 24 * 60 * 60 * 1000);

      const request: Observable<LocationVisibilityChangeDTO[]> | undefined =
              this.companyId != undefined
              ? this.locationAwarenessService.getVisibilityChangesForCompany(this.companyId, fromUtc)
              : this.iccid != undefined
                ? this.locationAwarenessService.getVisibilityChangesForSim(this.iccid, fromUtc, true)
                : undefined;

      if (request==undefined)
        return;

      this.visibilityChangesLoading=true;

      request.subscribe({
        next : data => {
          this.visibilityChanges       =(data ?? []).slice().sort((a, b) => (b?.changedAtUtc ?? '').localeCompare(a?.changedAtUtc ?? ''));
          this.visibilityChangesLoading=false;
        },
        error: error => {
          this.visibilityChangesLoading=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLocationChangeReasonChange(value: string): void {
    try {
      this.locationChangeReason=(value ?? '').substring(0, 512);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleVisibilityChanges(): void {
    try {
      this.visibilityChangesExpanded=!this.visibilityChangesExpanded;

      if (this.visibilityChangesExpanded)
        this.loadVisibilityChanges();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  private notifyLocationSettingsSaved(): void {
    try {
      this.refreshAwarenessStatus();
      this.globalEventService.broadcastLocationServicesChanged(this.iccid, <boolean>this.locationServices, this.instanceId, 'completed');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshAwarenessStatus(): void {
    try {
      if (this.locationOwnerUserId == undefined)
        return;

      this.locationAwarenessService.getStatus(this.locationOwnerUserId).subscribe({
        next : awareness => { this.applyAwarenessStatus(awareness); },
        error: error     => { this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resendLocationConsent(): void {
    try {
      if (this.locationOwnerUserId == undefined || this.locationConsentResending)
        return;

      this.locationConsentResending = true;

      this.locationAwarenessService.sendConsentRequest(this.locationOwnerUserId).subscribe({
        next : awareness => {
          this.locationConsentResending = false;
          this.applyAwarenessStatus(awareness);
        },
        error: error => {
          this.locationConsentResending = false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.locationConsentResending = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  private toggleProcessComplete() {
    try {
      var message   = `Location Services has been ${this.locationServicesToggleAction}d`;

      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesToggleLocationServices() {
    try {
      this.toggleInProgress = true;
    
      if (this.iccid != null && this.locationOwnerUserId != undefined) {
        this.devicesService.toggleLocationServices(this.locationOwnerUserId)
        .pipe(
          catchError((error) => {
            this.toggleInProgress = false;
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.locationServices = !this.locationServices;
            this.refreshAwarenessStatus();
            this.globalEventService.broadcastLocationServicesChanged(this.iccid, <boolean>this.locationServices, this.instanceId, 'completed');

            if (!this.locationServices) {
              this.locationCoordinates        = [];
              this.countryLocationCoordinates = [];
              this.loading                    = false;
            } else {
              if (this.showCurrentLocation) {
                this.getCurrentLocation();
              } else {
                this.getSIMLocations();
              }

            }

            this.toggleInProgress = false;

            this.toggleProcessComplete();
          },
          error: error => {
            this.globalEventService.broadcastLocationServicesChanged(this.iccid, <boolean>this.locationServices, this.instanceId, 'failed');
            if (error.message && error.message.includes("404")) {
              this.toggleInProgress = false;

              this.warningMessageMain="Location Services state change failed";
              this.warningMessageSub ="Please contact the application vendor for assistance";

              this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.toggleInProgress = false;
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      } else if (this.companyId != null) {
        this.devicesService.EnableLocationServices(this.companyId ?? -1)
        .pipe(
          catchError((error) => {
            this.toggleInProgress = false;
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.getCompanySIMLocations();
            this.toggleInProgress = false;
            this.EnableProcessComplete();
          },
          error: error => {
            if (error.message && error.message.includes("404")) {
              this.toggleInProgress = false;
  
              this.warningMessageMain="Location Services state change failed";
              this.warningMessageSub ="Please contact the application vendor for assistance";
  
              this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.toggleInProgress = false;
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
